/**
 * Español.
 *
 * Las claves vienen de `cs.js`. Si falta una, se muestra el texto en inglés
 * (y si tampoco existe, en checo), así que un hueco se nota.
 *
 * Traducción sin revisar todavía por una persona hablante nativa trans.
 * El lenguaje de la transición y las formas de género importan aquí más que
 * en otros sitios: si algo suena mal, dilo y lo cambiamos.
 */
const es = {

  // ── společné ──────────────────────────────────────────────────────────────
  'obecne.zpet': 'Volver',
  'obecne.hledat': 'Buscar',
  'obecne.nacitani': 'Cargando…',
  'obecne.zrusit': 'Cancelar',
  'obecne.ulozit': 'Guardar',
  'obecne.odeslat': 'Enviar',
  'obecne.vice': 'Ver todo',
  'obecne.jazyk': 'Idioma',

  // ── přihlášení a registrace ───────────────────────────────────────────────
  'auth.podtitulek': 'Un espacio seguro para la comunidad trans, donde puedes hablar con libertad, buscar ayuda y sentir el apoyo de las demás personas.',
  'auth.prihlaseni': 'Iniciar sesión',
  'auth.registrace': 'Crear cuenta',
  'auth.email': 'Correo electrónico',
  'auth.heslo': 'Contraseña',
  'auth.emailPriklad': 'tu@ejemplo.com',
  'auth.prihlasitSe': 'Iniciar sesión',
  'auth.prihlasuji': 'Iniciando sesión…',
  'auth.zapomenuteHeslo': '¿Has olvidado tu contraseña?',
  'auth.presGoogle': 'Iniciar sesión con Google',
  'auth.spatneUdaje': 'Correo o contraseña incorrectos',
  'auth.uspech': 'Sesión iniciada.',
  'auth.googleChyba': 'No se pudo iniciar sesión con Google',
  'auth.obnoveniHesla': 'Restablecer contraseña',
  'auth.obnoveniOdeslano': 'Si el correo está registrado, recibirás un enlace para restablecer la contraseña.',
  'auth.zpetNaPrihlaseni': 'Volver al inicio de sesión',
  'auth.odeslatOdkaz': 'Enviar el enlace',
  'auth.obnoveniChyba': 'No se pudo enviar el correo. Inténtalo de nuevo.',

  // druhý krok přihlášení
  'auth.jesteKod': 'Un paso más: tu código',
  'auth.jesteKodPopis': 'Abre tu aplicación de autenticación y copia los seis dígitos que muestra para Bloom.',
  'auth.kod': 'Código',
  'auth.zalozniKodNapoveda': '¿No tienes el móvil a mano? Escribe uno de los códigos de respaldo que guardaste al activarlo.',
  'auth.potvrdit': 'Confirmar',
  'auth.overuji': 'Comprobando…',
  'auth.kodNesedi': 'Ese código no es correcto',
  'auth.zalozniDochazeji': (p) => `Solo te quedan ${p.pocet} códigos de respaldo. Genera unos nuevos en tu perfil.`,

  // instalace a zabezpečení
  'auth.instalaceTitulek': 'Cómo instalar Bloom en tu móvil',
  'auth.krokyAndroid': [
      'Abre esta página en Chrome',
      'Toca el icono de los tres puntos (⋮) arriba a la derecha',
      'Elige «Añadir a pantalla de inicio» o «Instalar aplicación»',
      'Confirma la instalación',
    ],
  'auth.krokyIos': [
      'Abre esta página en Safari',
      'Toca el icono de compartir (□↑) en la barra inferior',
      'Baja y elige «Añadir a pantalla de inicio»',
      'Confirma tocando «Añadir»',
    ],
  'auth.seznamChranene': [
      { silne: 'Nada de las personas miembros es público.', text: 'Los perfiles, las historias, las ofertas, las preguntas, las fotos y los avatares solo se muestran a quien ha iniciado sesión. Nada de eso se puede descargar ni recopilar sin una cuenta.' },
      { silne: 'Nadie conoce tu contraseña', text: '— nosotras tampoco. Se guarda como un hash bcrypt, del que no se puede recuperar la original.' },
      { silne: 'Los mensajes privados y los archivos adjuntos están cifrados', text: '(AES + comprobación de integridad) ya en el disco del servidor. Quien consiguiera una copia de seguridad o el disco solo leería caracteres sin sentido.' },
      { silne: 'Los mensajes se borran solos', text: 'pasado un tiempo (90 días por defecto), incluidas las notas de voz y las fotos. Lo que no está aquí no se puede filtrar.' },
      { silne: 'Tu etapa de transición es privada', text: 'hasta que la publiques. Nadie más ve los pasos que marcas en la Guía.' },
      { silne: 'El correo y el teléfono', text: 'nunca se muestran a otras personas.' },
      { silne: '', text: 'El inicio de sesión está protegido contra los intentos de adivinar la contraseña, limitando el número de intentos.' },
      { silne: 'Cifrado de extremo a extremo de los mensajes.', text: 'Cuando lo activas, el texto y los archivos se cifran en tu propio navegador y el servidor solo recibe caracteres ilegibles. La clave se abre con tu contraseña y nunca sale de tu dispositivo, así que nosotras tampoco podemos leer el contenido, ni aunque lo pidiera un juzgado. El precio es que, si olvidas la contraseña, tú tampoco podrás leer los mensajes antiguos.' },
      { silne: '', text: 'La sesión no se queda abierta: Bloom la cierra cuando cierras la ventana y tras diez minutos de inactividad.' },
    ],
  'auth.seznamNeumime': [
      { silne: 'Los metadatos', text: '— quién escribe a quién y cuándo — los tiene que conocer el servidor para poder entregar el mensaje. El cifrado de extremo a extremo no los oculta, y Signal tampoco.' },
      { silne: '', text: 'Bloom es una aplicación web, así que descarga su código de cifrado de nuestro servidor cada vez que la abres. Quien se hiciera con el servidor podría, en teoría, servir un código modificado. Contra eso solo protege una aplicación firmada de una tienda — por eso Signal la tiene y una versión web no.' },
      { silne: 'Los perfiles', text: '— apodo, descripción, avatar — no se pueden cifrar, porque el servidor tiene que mostrarlos a las demás personas.' },
      { silne: '', text: 'Los mensajes anteriores a activar el cifrado quedan cifrados solo en el disco del servidor, no de extremo a extremo.' },
    ],
  'auth.instalaceAndroid': 'Android',
  'auth.instalaceIos': 'iPhone / iPad',
  'auth.instalacePoznamka': 'Bloom funciona como una aplicación, incluso sin conexión. Tus datos siempre están al día.',
  'auth.zabezpeceniTitulek': 'Cómo está protegido Bloom',
  'auth.zabezpeceniUvod': 'Bloom es un espacio para la comunidad trans, así que aquí se juntan cosas delicadas. Abajo está lo que '
      + 'hacemos para protegerlas — y lo que no podemos hacer — sin adornos.',
  'auth.coJeChranene': 'Qué está protegido',
  'auth.coNeumime': 'Lo que Bloom no puede hacer — y es justo decirlo',
  'auth.zabezpeceniZaver': 'Si tienes alguna duda sobre privacidad o has encontrado un fallo, usa «Informar de un problema» abajo. Nos lo tomamos en serio.',
  'auth.mvp': 'Bloom está en su primera versión y la vamos mejorando junto con la comunidad. '
      + 'Si te encuentras un fallo o tienes una idea, nos alegrará saberlo.',
  'auth.nahlasitProblem': 'Informar de un problema',
  'auth.clenu': (p) => (p.pocet === 1 ? 'persona miembro' : 'personas miembros'),
  'auth.prispevku': (p) => (p.pocet === 1 ? 'publicación' : 'publicaciones'),
  'auth.odborniku': (p) => (p.pocet === 1 ? 'profesional' : 'profesionales'),
  'auth.nabidek': (p) => (p.pocet === 1 ? 'oferta' : 'ofertas'),

  // ── registrace ────────────────────────────────────────────────────────────
  'reg.prezdivka': 'Apodo (único)',
  'reg.prezdivkaPriklad': 'Al menos 3 caracteres',
  'reg.telefon': 'Teléfono',
  'reg.volitelne': '(opcional)',
  'reg.heslo': 'Contraseña',
  'reg.hesloZnovu': 'Repite la contraseña',
  'reg.zajmeno': 'Pronombres',
  'reg.oMne': 'Sobre mí',
  'reg.oMnePriklad': 'Unas palabras sobre ti…',
  'reg.registrovat': 'Crear cuenta',
  'reg.registruji': 'Creando la cuenta…',
  'reg.presGoogle': 'Registrarse con Google',
  'reg.avatar': 'Avatar',
  'reg.neboFoto': 'O sube tu propia foto',
  'reg.nahratFoto': 'Subir foto',
  'reg.vlastni': 'Propia',
  'reg.zeme': 'País',
  'reg.kraj': 'Región',
  'reg.nechciUvadet': 'Prefiero no decirlo',
  'reg.cesko': 'Chequia',
  'reg.svet': 'Resto del mundo',

  // skupiny avatarů
  'reg.avatarFem': 'Femeninos',
  'reg.avatarMask': 'Masculinos',
  'reg.avatarNeutr': 'Neutros',
  'reg.avatarZvirata': 'Animales',

  // komunitní heslo
  'reg.komunitniHeslo': 'Contraseña de la comunidad',
  'reg.komunitniHesloPriklad': 'Escribe la contraseña de la comunidad…',
  'reg.komunitniHesloPopis': 'Bloom es un espacio privado para la comunidad trans. Alguien de la comunidad puede darte la contraseña.',
  'reg.napisAdminovi': 'Si no conoces a nadie, escribe a la administración a',
  'reg.nevimHeslo': 'No sé la contraseña de la comunidad',
  'reg.jakZiskat': 'La contraseña de la comunidad protege este espacio privado. Cómo conseguirla:',
  'reg.krok1': '1. Escribe un correo a',
  'reg.krok2': '2. Preséntate brevemente y cuenta cómo has sabido de Bloom',
  'reg.krok3': '3. La administración te responderá lo antes posible',

  // kontrola hesla
  'reg.hesloKratke': 'La contraseña tiene que tener al menos 8 caracteres',
  'reg.hesloMale': 'La contraseña tiene que llevar una letra minúscula',
  'reg.hesloVelke': 'La contraseña tiene que llevar una letra mayúscula',
  'reg.hesloCislo': 'La contraseña tiene que llevar un número',
  'reg.hesloZnak': 'La contraseña tiene que llevar un carácter especial (!@#$%…)',
  'reg.pozadavek8': 'Al menos 8 caracteres',
  'reg.pozadavekVelke': 'Letra mayúscula',
  'reg.pozadavekCislo': 'Número',
  'reg.pozadavekZnak': 'Carácter especial (!@#$%)',
  'reg.hesloNesouhlasi': 'Las contraseñas no coinciden',
  'reg.prezdivkaKratka': 'El apodo tiene que tener al menos 3 caracteres',
  'reg.hesloPovinne': 'La contraseña de la comunidad es obligatoria',
  'reg.hotovo': 'Cuenta creada. Revisa tu correo para verificarla.',
  'reg.fotoVelka': 'La imagen es demasiado grande (máx. 2 MB)',
  'reg.chyba': 'No se ha podido crear la cuenta',

  // ── domovská stránka ──────────────────────────────────────────────────────
  'domu.citat': 'Aquí nadie tiene que ser perfecta. Bloom es un espacio donde cada persona puede ser quien es — '
      + 'donde puedes compartir tu experiencia, preguntar y ayudar a las demás. Sin juicios y sin prejuicios.',
  'domu.citatAutor': '— Martina Sobková',
  'domu.prelozenoZCestiny': ' · traducido del checo',
  'domu.vitej': 'Hola,',
  'domu.vCislech': 'Bloom en números',
  'domu.noveVKomunite': '¿Es tu primera vez?',
  'domu.noveVKomunitePopis1': 'No tienes que dejarte ver. No necesitas foto. No tienes que estar fuera del armario.',
  'domu.noveVKomunitePopis2': 'Bloom es un espacio donde puedes empezar a tu ritmo.',
  'domu.rozcestnik1': 'Es mi primera vez aquí',
  'domu.rozcestnik2': 'No sé por dónde empezar',
  'domu.rozcestnik3': 'Quiero mantener el anonimato',
  'domu.rozcestnik4': 'Busco profesionales',
  'domu.rozcestnik5': 'Solo quiero leer experiencias',
  'domu.otazky': '¿Tienes dudas o quieres saber más? Escríbenos a',
  'domu.doporucujeme': 'Recomendado',
  'domu.odbornici': 'Profesionales',
  'domu.noviClenove': 'Nuevas personas en la comunidad',
  'domu.zadniNovi': 'Todavía no hay nadie nuevo',
  'domu.nejnovejsiOtazky': 'Últimas preguntas',
  'domu.zadneOtazky': 'Todavía no hay preguntas.',
  'domu.nejlepeHodnoceni': 'Profesionales mejor valorados',
  'domu.zadniHodnoceni': 'Todavía no hay valoraciones',
  'domu.zadneAktuality': 'Todavía no hay noticias',

  // dlaždice sekcí
  'domu.dlazdice.support': 'Ofrece lo que sabes hacer y recibe ayuda de otras personas.',
  'domu.dlazdice.specialists': 'Encuentra profesionales verificados, de psicología a cirugía plástica.',
  'domu.dlazdice.legal': 'Ayuda legal, artículos y respuestas a tus preguntas.',
  'domu.dlazdice.nearby': 'Servicios y profesionales cerca de ti.',

  // počty
  'domu.pocetClenu': (p) => (p.pocet === 1 ? 'persona en la comunidad' : 'personas en la comunidad'),
  'domu.pocetZkusenosti': (p) => (p.pocet === 1 ? 'experiencia compartida' : 'experiencias compartidas'),
  'domu.pocetOdborniku': (p) => (p.pocet === 1 ? 'profesional verificado' : 'profesionales verificados'),
  'domu.pocetNabidek': (p) => (p.pocet === 1 ? 'oferta de apoyo mutuo' : 'ofertas de apoyo mutuo'),

  // ── navigace a společné ovládání ──────────────────────────────────────────
  'nav.domu': 'Inicio',
  'nav.news': 'Actualidad',
  'nav.stories': 'Experiencias de la comunidad',
  'nav.mapaSveta': 'Mapa del mundo',
  'nav.support': 'Apoyo mutuo',
  'nav.specialists': 'Profesionales trans-friendly',
  'nav.legal': 'Ayuda legal',
  'nav.pageants': 'Certámenes',
  'nav.nearby': 'Cerca de mí',
  'nav.hledat': 'Buscar en Bloom',
  'nav.hledatPlaceholder': 'Buscar personas, profesionales, artículos…',
  'nav.zpravy': 'Mensajes',
  'nav.profil': 'Mi perfil',
  'nav.mojeCesta': 'Mi camino',
  'nav.administrace': 'Administración',
  'nav.odhlasit': 'Cerrar sesión',
  'nav.vsechnyVysledky': (p) => `Ver todos los resultados de «${p.dotaz}»`,
  'nav.overEmail': 'Verifica tu correo',
  'nav.menu': 'Menú',

  // ── mapa světa ────────────────────────────────────────────────────────────
  'svet.titulek': 'Bloom por el mundo',
  'svet.podtitulek': 'Elige un país y mira lo que la comunidad ha reunido allí.',
  'svet.hledatZemi': 'Buscar un país…',
  'svet.vsechnyZeme': 'Todos los países',
  'svet.jenSObsahem': 'Solo países con contenido',
  'svet.nicNenalezeno': 'Ningún país coincide.',
  'svet.zaznamu': (p) => `${p.pocet} ${p.pocet === 1 ? 'entrada' : 'entradas'}`,
  'svet.prazdnaZeme': 'Todavía nada',
  'svet.kontinent': 'Continente',
  'svet.celySvet': 'Todo el mundo',
  'svet.vse': 'Todo',
  'svet.zacniDomovem': 'Empieza eligiendo el país al que llamas casa. También puedes elegirlo en la lista de debajo del mapa.',
  'svet.zkoumej': 'Elige un país y mira lo que Bloom tiene allí. Puedes mirar donde quieras — '
      + 'eso no cambia tu país de residencia.',
  'svet.domov': 'Casa',
  'svet.zrusitDomov': 'Quitar el país de residencia',
  'svet.nastavitDomov': 'Marcar como mi país',
  'svet.zeSveta': 'Por el mundo',
  'svet.coSeChysta': 'Qué se prepara',
  'svet.souteze': 'Certámenes con inscripción abierta',
  'svet.noveOrganizace': 'Organizaciones nuevas',
  'svet.kdeJizNeco': 'Donde Bloom ya tiene algo',
  'svet.hledatZemiPopisek': 'Buscar un país',
  'svet.nicNeodpovida': 'No hay coincidencias. Prueba otra búsqueda.',
  'svet.napovedaKMape': 'Arrastra el mapa para moverlo y usa la rueda o los botones para acercarlo. No tienes '
      + 'por qué usarlo: abajo están el buscador y la lista completa de países.',
  'svet.tvujBloom': (p) => `Tu Bloom en ${p.zeme}`,
  'svet.tvojeDomovska': 'tu país de residencia',
  'svet.zemi': (p) => `${p.pocet} ${p.pocet === 1 ? 'país' : 'países'}`,
  'svet.chyba': 'No se han podido cargar los países. Vuelve a cargar la página.',
  'svet.pocet.specialists': (p) => `${p.pocet} ${p.pocet === 1 ? 'profesional' : 'profesionales'}`,
  'svet.pocet.organizations': (p) => `${p.pocet} ${p.pocet === 1 ? 'organización' : 'organizaciones'}`,
  'svet.pocet.events': (p) => `${p.pocet} ${p.pocet === 1 ? 'evento' : 'eventos'}`,
  'svet.pocet.pageants': (p) => `${p.pocet} ${p.pocet === 1 ? 'certamen' : 'certámenes'}`,
  'svet.pocet.resources': (p) => `${p.pocet} ${p.pocet === 1 ? 'recurso' : 'recursos'}`,

  // světadíly
  'kontinent.europe': 'Europa',
  'kontinent.asia': 'Asia',
  'kontinent.africa': 'África',
  'kontinent.north_america': 'América del Norte',
  'kontinent.south_america': 'América del Sur',
  'kontinent.oceania': 'Oceanía',
  'kontinent.antarctica': 'Antártida',

  // ── soutěže napříč světem ─────────────────────────────────────────────────
  'souteze.podtitulek': 'Certámenes trans de todo el mundo. Arriba están aquellos en los que todavía puedes inscribirte.',
  'souteze.hledat': 'Buscar un certamen…',
  'souteze.zadne': 'Todavía no tenemos certámenes. ¿Conoces alguno? Envía una sugerencia.',

  // ── náhled země pod mapou ─────────────────────────────────────────────────
  'nahled.otevrit': (p) => `Abrir ${p.zeme}`,
  'nahled.zavrit': 'Cerrar la vista previa',
  'nahled.jenInformace': 'De momento solo tenemos información sobre el país.',
  'nahled.zatimNic': 'Todavía no tenemos aquí contactos, organizaciones ni eventos. ¿Sabes de alguno? Envía una sugerencia.',
  // ── stránka země ──────────────────────────────────────────────────────────
  'zeme.titulek': (p) => `Bloom en ${p.zeme}`,
  'zeme.podtitulek': (p) => `Lo que la comunidad ha reunido en ${p.zeme}.`,
  'zeme.prazdna': 'Bloom está empezando aquí. Podrías ser la primera persona en añadir algo.',
  'zeme.mapaSveta': 'Mapa del mundo',
  'zeme.navrhnout': 'Sugerir una entrada',
  'zeme.domovska': 'Tu país de residencia',
  'zeme.nastavitDomovskou': 'Marcar como mi país',
  'zeme.kdeToJe': 'Dónde encontrarlo',
  'zeme.coTuBude': 'Qué encontrarás aquí',
  'zeme.zatimPrazdne': 'de momento vacío',
  'zeme.pripravujeme': 'en preparación',
  'zeme.zobrazitVse': (p) => `Ver todo (${p.pocet})`,
  'zeme.rosteTitulek': 'Bloom apenas está creciendo aquí',
  'zeme.rostePopis': 'Todavía no tenemos nada aquí. ¿Conoces una organización, un evento o un '
      + 'contacto útil? Envía una sugerencia: pasa por revisión y luego aparece aquí.',
  'zeme.jinouZemi': 'Mirar otros países',
  'zeme.bezKontaktu': 'Todavía no tenemos aquí contactos ni organizaciones.',
  'zeme.bezKontaktuPopis': '¿Conoces a alguien o algo útil por aquí? Envía una sugerencia: pasa por '
      + 'revisión y luego aparece aquí.',
  'zeme.neznama': 'No conocemos ese país.',
  'zeme.chyba': 'No se ha podido cargar el país.',

  // ── sekce ─────────────────────────────────────────────────────────────────
  'sekce.specialists': 'Consultas y clínicas',
  'sekce.specialists.popis': 'Profesionales de la salud, clínicas y otras personas con las que la comunidad tiene experiencia.',
  'sekce.organizations': 'Organizaciones',
  'sekce.organizations.popis': 'Asociaciones, entidades sin ánimo de lucro y grupos de apoyo.',
  'sekce.events': 'Eventos',
  'sekce.events.popis': 'Encuentros, Orgullo, talleres y congresos.',
  'sekce.pageants': 'Certámenes',
  'sekce.pageants.popis': 'Certámenes trans y sus fechas.',
  'sekce.resources': 'Recursos',
  'sekce.resources.popis': 'Información práctica sobre este país.',
  'sekce.community': 'Comunidad',
  'sekce.community.popis': 'Personas y grupos de este país.',
  'sekce.legal': 'Ayuda legal',
  'sekce.legal.popis': 'Información y apoyo para la comunidad trans',
  'sekce.support': 'Apoyo mutuo',
  'sekce.support.popis': 'Ofrece lo que sabes hacer y recibe ayuda de otras personas de la comunidad',

  // ── výpis záznamů ─────────────────────────────────────────────────────────
  'vypis.hledatVZemi': 'Buscar en este país…',
  'vypis.vsechnyKategorie': 'Todas las categorías',
  'vypis.kategorie': 'Categoría',
  'vypis.celaZeme': 'Todo el país',
  'vypis.navrhnout': 'Sugerir',
  'vypis.nicNeodpovida': 'No hay coincidencias. Prueba otra búsqueda o quita el filtro.',
  'vypis.zadneZaznamy': (p) => `Todavía no tenemos entradas en ${p.zeme}.`,
  'vypis.zaznamu': (p) => `${p.pocet} ${p.pocet === 1 ? 'entrada' : 'entradas'}`,
  'vypis.predchozi': 'Anterior',
  'vypis.dalsi': 'Siguiente',
  'vypis.chyba': 'No se han podido cargar las entradas.',
  'vypis.neznamyDruh': 'No conocemos ese tipo de entrada.',

  // ── detail záznamu ────────────────────────────────────────────────────────
  'detail.zpetNa': (p) => `Volver a ${p.zeme}`,
  'detail.kontakty': 'Contacto y enlaces',
  'detail.podrobnosti': 'Detalles',
  'detail.zacatek': 'Empieza',
  'detail.termin': 'Fecha',
  'detail.uzaverka': 'Cierre de inscripciones',
  'detail.prihlaska': 'Inscripción',
  'detail.strankaAkce': 'Página del evento',
  'detail.web': 'Web',
  'detail.konec': 'Termina',
  'detail.stavRocniku': 'Estado de la edición',
  'detail.oblasti': 'Áreas de trabajo',
  'detail.coNabizi': 'Qué ofrecen',
  'detail.kategorie': 'Categorías',
  'detail.jazyky': 'Idiomas',
  'detail.vitezove': 'Ganadoras anteriores',
  'detail.kdoSeMuze': 'Quién puede participar',
  'detail.poradatel': 'Organiza',
  'detail.poplatek': 'Cuota',
  'detail.tema': 'Tema',
  'detail.forma.offline': 'Presencial',
  'detail.forma.online': 'En línea',
  'detail.forma.hybrid': 'Presencial y en línea',
  'detail.rozsah.local': 'Local',
  'detail.rozsah.national': 'Nacional',
  'detail.rozsah.international': 'Internacional',
  'detail.rocnik.upcoming': 'Próximamente',
  'detail.rocnik.registration_open': 'Inscripción abierta',
  'detail.rocnik.registration_closed': 'Inscripción cerrada',
  'detail.rocnik.completed': 'Celebrado',
  'detail.zdroj': (p) => `Fuente: ${p.zdroj}`,
  'detail.upraveno': (p) => `Última actualización: ${p.datum}`,
  'detail.overeno': 'Comprobado que la información es correcta. No es una recomendación de Bloom.',
  'detail.neovereno': 'Esta entrada todavía no está verificada. Los datos pueden haber cambiado: consúltalo en la fuente.',
  'detail.nenalezen': 'No conocemos esa entrada. Puede que se haya borrado o que siga en revisión.',
  'detail.chyba': 'No se ha podido cargar la entrada.',

  // ── profil země ───────────────────────────────────────────────────────────
  'profil.coTuPlati': 'Qué se aplica aquí',
  'profil.name_change': 'Cambio de nombre',
  'profil.gender_marker': 'Cambio del sexo registral',
  'profil.surgery_required': 'Requisito de cirugía',
  'profil.healthcare': 'Acceso a la atención sanitaria',
  'profil.legal_protection': 'Protección contra la discriminación',
  'profil.safety': 'Seguridad',
  'profil.stav.yes': 'Sí',
  'profil.stav.limited': 'En parte',
  'profil.stav.no': 'No',
  'profil.stav.unknown': 'Sin datos',
  'profil.zdroj': 'Fuente',
  'profil.zdrojZRoku': (p) => `fuente de ${p.rok}`,
  'profil.overeno': (p) => `Comprobado el ${p.datum}`,
  'profil.zmena': 'Cambio reciente',
  'profil.odKdy': (p) => `en vigor desde ${p.datum}`,
  'profil.doklady': 'Fuentes',
  'profil.zakon': 'ley o sentencia',
  'profil.upozorneni': 'Esto no es asesoramiento jurídico. Las leyes cambian y mucho depende de tu '
      + 'situación concreta: consulta la fuente o una organización de ese '
      + 'país antes de actuar.',

  // ── formulář návrhu ───────────────────────────────────────────────────────
  'navrh.titulek': (p) => `Sugerir ${p.druh}${p.zeme ? ` — ${p.zeme}` : ''}`,
  'navrh.popisFormulare': 'Tu sugerencia pasa por revisión antes de aparecer en Bloom. Rellena lo que '
      + 'sepas: el resto lo completamos nosotras.',
  'navrh.jednotne.organizations': 'una organización',
  'navrh.jednotne.events': 'un evento',
  'navrh.jednotne.pageants': 'un certamen',
  'navrh.jednotne.resources': 'un recurso',
  'navrh.popis.organizations': 'Una asociación, una entidad sin ánimo de lucro o un grupo de apoyo.',
  'navrh.popis.events': 'Un encuentro, el Orgullo, un taller, un congreso.',
  'navrh.popis.pageants': 'Un certamen trans: fecha, inscripción, quién lo organiza.',
  'navrh.popis.resources': 'Información práctica: sanidad, derecho, documentos, contactos.',
  'navrh.nazev': 'Nombre',
  'navrh.popisPole': 'Descripción',
  'navrh.zeme': 'País',
  'navrh.mesto': 'Ciudad',
  'navrh.adresa': 'Dirección',
  'navrh.web': 'Web',
  'navrh.email': 'Correo electrónico',
  'navrh.telefon': 'Teléfono',
  'navrh.odkudVis': 'De dónde lo sabes',
  'navrh.odkudVisPriklad': 'p. ej. de su web, estuve allí…',
  'navrh.vyberte': '— elige —',
  'navrh.forma': 'Formato',
  'navrh.rozsah': 'Alcance',
  'navrh.platiPro': 'Se aplica a',
  'navrh.platnost.global': 'Todo el mundo',
  'navrh.platnost.country': 'Un país',
  'navrh.platnost.region': 'Una región',
  'navrh.platnost.city': 'Una ciudad',
  'navrh.odkazAkce': 'Enlace al evento',
  'navrh.odkazPrihlaska': 'Enlace a la inscripción',
  'navrh.odkazy': 'Enlaces',
  'navrh.text': 'Texto',
  'navrh.odeslat': 'Enviar la sugerencia',
  'navrh.odesilam': 'Enviando…',
  'navrh.chyba': 'No se ha podido enviar la sugerencia',
  'navrh.dikyTitulek': 'Gracias, ya lo tenemos',
  'navrh.dikyPopis': 'Hemos recibido tu sugerencia. Alguien la revisará y después aparecerá '
      + 'en Bloom. Nada se publica de forma automática.',
  'navrh.zavrit': 'Cerrar',
  'navrh.seznamNapoveda': 'Separa los elementos con comas.',

  // ── převzetí profilu ──────────────────────────────────────────────────────
  'prevzeti.patriVam': (p) => `¿${p.druh} es tuya?`,
  'prevzeti.popis': 'Puedes hacerte cargo del perfil y mantener los datos al día. '
      + 'La solicitud pasa primero por revisión.',
  'prevzeti.tlacitko': 'Hacerme cargo de este perfil',
  'prevzeti.spravujes': 'Gestionas este perfil. Puedes corregir los datos cuando quieras: los cambios se aplican al momento.',
  'prevzeti.upravit': 'Editar los datos',
  'prevzeti.spravujeSama': (p) => `Este perfil lo gestiona ${p.druh} directamente.`,
  'prevzeti.ceka': 'Hemos recibido tu solicitud y la estamos revisando.',
  'prevzeti.formulacTitulek': (p) => `Hacerse cargo del perfil — ${p.nazev}`,
  'prevzeti.formulacPopis': 'Antes de entregarte el perfil necesitamos saber que de verdad formas parte de la '
      + 'organización. La solicitud pasa por revisión; de momento no cambia nada.',
  'prevzeti.role': '¿Cuál es tu papel allí?',
  'prevzeti.rolePriklad': 'p. ej. coordinadora, presidencia de la asociación',
  'prevzeti.doklad': '¿Cómo podemos comprobarlo?',
  'prevzeti.dokladPriklad': 'p. ej. aparezco en la web de la organización, en contacto; o escribe desde una dirección oficial',
  'prevzeti.dokladNapoveda': 'Basta con un enlace a una página donde aparezcas, o la dirección oficial '
      + 'de la organización desde la que escribir.',
  'prevzeti.kontakt': 'Tu contacto',
  'prevzeti.kontaktPriklad': 'correo o teléfono',
  'prevzeti.dalsi': 'Algo más',
  'prevzeti.nepovinne': '(opcional)',
  'prevzeti.odeslat': 'Enviar la solicitud',
  'prevzeti.odesilam': 'Enviando…',
  'prevzeti.vyplnObe': 'Cuéntanos cuál es tu papel y cómo se puede comprobar.',
  'prevzeti.prijato': 'Gracias. Hemos recibido tu solicitud y te responderemos.',
  'prevzeti.chyba': 'No se ha podido enviar la solicitud.',
  'prevzeti.upravaTitulek': (p) => `Editar el perfil — ${p.nazev}`,
  'prevzeti.upravaPopis': 'El nombre y la ubicación no están aquí a propósito: las entradas se buscan y '
      + 'se ordenan por ellos. Si han cambiado, escríbenos y los actualizamos.',
  'prevzeti.popisPole': 'Descripción',
  'prevzeti.email': 'Correo electrónico',
  'prevzeti.telefon': 'Teléfono',
  'prevzeti.web': 'Web',
  'prevzeti.ulozeno': 'Guardado.',
  'prevzeti.ukladam': 'Guardando…',
  'prevzeti.chybaUlozeni': 'No se ha podido guardar.',
  'prevzeti.druh.organizations': 'la organización',
  'prevzeti.druh.events': 'el evento',
  'prevzeti.druh.pageants': 'el certamen',

  // ── profil ────────────────────────────────────────────────────────────────
  'profil.upravteUdaje': 'Edita tus datos y ajustes',
  'profil.overeny': 'Verificado',
  'profil.neovereny': 'Sin verificar',
  'profil.overteEmail': 'Verifica tu correo. Una cuenta sin verificar tiene permisos limitados.',
  'profil.emailOdeslan': 'Correo de verificación enviado.',
  'profil.emailChyba': 'No se ha podido enviar el correo',
  'profil.odeslano': 'Enviado.',
  'profil.overeniOdbornika': 'Verificación como profesional o abogacía',
  'profil.pracujeteVOboru': '¿Trabajas en el sector? Consigue la insignia de verificación.',
  'profil.zadostOdeslana': 'Solicitud enviada',
  'profil.pozadatOOvereni': 'Solicitar la verificación',
  'profil.zadostTitulek': 'Solicitar la verificación como profesional o abogacía',
  'profil.zadostPopis': 'Rellena los datos de tu solicitud. La moderación la revisará.',
  'profil.pozadovanaRole': 'Rol solicitado',
  'profil.roleOdbornik': 'Profesional',
  'profil.rolePravnik': 'Abogacía',
  'profil.specializace': 'Especialidad',
  'profil.odkazNaProfil': 'Enlace a un perfil profesional',
  'profil.zpravaProAdmina': 'Un mensaje breve para la administración',
  'profil.odesilam': 'Enviando…',
  'profil.odeslatZadost': 'Enviar la solicitud de verificación',
  'profil.vyplnteSpecializaci': 'Rellena tu especialidad',
  'profil.zadostUspech': 'Tu solicitud de verificación se ha enviado.',
  'profil.zadostChyba': 'No se ha podido enviar la solicitud',

  // bezpečnost
  'bezp.titulek': 'Seguridad',
  'bezp.sifrovaniZapnuto': (p) => `El cifrado de mensajes está activado${p.odemceno ? ' y desbloqueado' : ' (bloqueado en esta pestaña)'}.`,
  'bezp.sifrovaniVypnuto': 'Todavía no tienes activado el cifrado de mensajes.',
  'bezp.sifrovaniKde': 'Se activa y se desbloquea en la página de Mensajes.',
  'bezp.sifrovaniKdeVypnute': 'Puedes activarlo desde la página de Mensajes, en cualquier conversación.',
  'bezp.zmenaHesla': 'Cambiar la contraseña',
  'bezp.zmenaHeslaSifrovani': 'Tienes el cifrado activado, así que al cambiar la contraseña se vuelve a envolver la clave de tus mensajes. '
      + 'Por eso hace falta la contraseña actual: sin ella no se podría abrir la clave y perderías tus mensajes.',
  'bezp.stavajiciHeslo': 'Contraseña actual',
  'bezp.noveHeslo': 'Nueva contraseña',
  'bezp.noveHesloZnovu': 'Repite la nueva contraseña',
  'bezp.pozadavky': 'Al menos 8 caracteres, mayúsculas y minúsculas, un número y un carácter especial.',
  'bezp.zmenitHeslo': 'Cambiar la contraseña',
  'bezp.menim': 'Cambiando…',
  'bezp.hesloNeshoda': 'Las contraseñas nuevas no coinciden.',
  'bezp.vyplnObe': 'Rellena las dos contraseñas.',
  'bezp.stareNesedi': 'La contraseña actual no es correcta: se perdería la clave de tus mensajes, así que no se ha cambiado nada.',
  'bezp.zmenenoSKlicem': 'Contraseña cambiada. La clave de tus mensajes se ha vuelto a envolver, así que los mensajes antiguos siguen legibles.',
  'bezp.zmeneno': 'Contraseña cambiada.',
  'bezp.zmenaChyba': 'No se ha podido cambiar la contraseña.',
  'bezp.nepamatujes': '¿No recuerdas la contraseña de la clave?',
  'bezp.zahoditPopis': 'Puedes descartar la clave y empezar de nuevo. Los mensajes cifrados hasta ahora se perderán para siempre: '
      + 'nadie puede leerlos, nosotras tampoco. Y precisamente por eso es seguro.',
  'bezp.zahodit': 'Descartar las claves y empezar de nuevo',
  'bezp.zahoditPotvrzeni': '¿Descartar de verdad las claves?\n\nTodos los mensajes cifrados hasta ahora se perderán para siempre: '
      + 'nadie puede leerlos, nosotras tampoco. Hazlo solo si no recuerdas la contraseña '
      + 'que usaste al activar el cifrado.',
  'bezp.klicSmazan': 'Claves borradas. Vuelve a cargar la página.',
  'bezp.nepovedlo': 'No ha funcionado.',
  'bezp.prohlizecNeumi': 'Este navegador no admite el cifrado que usa Bloom.',

  'profil.mujProfil': 'Mi perfil',
  'profil.specializacePriklad': 'p. ej. psicología, sexología, abogacía…',
  'profil.zpravaPriklad': 'Por ejemplo un enlace a tu colegiación o a la web de tu consulta…',
  'profil.overeniUvod': '¿Quieres ser profesional o abogacía verificada en Bloom? Envía una solicitud de verificación. '
      + 'Tu perfil tiene que corresponder con tu profesión real.',

  'profil.oborPriklad': 'p. ej. cirugía plástica, derecho de familia…',
  'profil.nepovinnyText': 'Nota adicional, opcional…',
  // ── dvoufázové přihlášení ─────────────────────────────────────────────────
  'dvf.titulek': 'Verificación en dos pasos',
  'dvf.zapnuto': (p) => `Activada. Te quedan ${p.pocet} códigos de respaldo.`,
  'dvf.vypnuto': 'Además de la contraseña, escribes un código de seis dígitos de una aplicación de tu móvil.',
  'dvf.chraniA': 'Protege',
  'dvf.chraniPrihlaseni': 'el inicio de sesión',
  'dvf.chraniB': ': quien sepa tu contraseña pero no tenga tu móvil no podrá entrar.',
  'dvf.nechrani': 'No protege los mensajes cifrados',
  'dvf.nechraniPopis': ' — esos se abren con tu contraseña en tu propio navegador y el servidor no participa.',
  'dvf.ulozKody': 'Guarda estos diez códigos de respaldo',
  'dvf.ulozKodyPopis1': 'Cada uno funciona una sola vez y son la única forma de entrar si pierdes el móvil.',
  'dvf.znovuNeukaze': 'Nadie te los volverá a enseñar',
  'dvf.ulozKodyPopis2': ' — solo guardamos su huella.',
  'dvf.zkopirovat': 'Copiar',
  'dvf.ulozilaJsem': 'Ya los he guardado',
  'dvf.zkopirovano': 'Copiado.',
  'dvf.kopieChyba': 'No se han podido copiar, apúntalos a mano.',
  'dvf.zapnout': 'Activar la verificación en dos pasos',
  'dvf.pripravuji': 'Preparando…',
  'dvf.nactiKod': 'Escanea este código en una aplicación de autenticación: por ejemplo Google Authenticator, Authy, 1Password o Aegis.',
  'dvf.qrNejde': '¿No puedes escanear el código QR?',
  'dvf.zadejRucne': 'Escribe esta clave en la aplicación a mano:',
  'dvf.opisKod': 'Escribe el código que muestra la aplicación',
  'dvf.zapnoutKratce': 'Activar',
  'dvf.overuji': 'Comprobando…',
  'dvf.noveKody': 'Nuevos códigos de respaldo',
  'dvf.vypnout': 'Desactivar',
  'dvf.noveKodyPopis': 'El nuevo juego sustituye al anterior: tus códigos de respaldo actuales dejarán de funcionar.',
  'dvf.kodZAplikace': 'Código de la aplicación',
  'dvf.vygenerovat': 'Generar',
  'dvf.vypnutiPopis': 'Para desactivarla hacen falta tu contraseña y un código válido. Las dos cosas a propósito: si no, cualquiera con acceso a un navegador abierto podría quitarla.',
  'dvf.kodNeboZalozni': 'Código de la aplicación o código de respaldo',
  'dvf.vypinam': 'Desactivando…',
  'dvf.vypnoutCele': 'Desactivar la verificación en dos pasos',
  'dvf.vypnuto2': 'Verificación en dos pasos desactivada.',
  'dvf.kodNesedi': 'Ese código no es correcto.',
  'dvf.nepovedlo': 'No ha funcionado.',

  // ── formulář profilu ──────────────────────────────────────────────────────
  'pf.ulozeno': 'Perfil actualizado.',
  'pf.chyba': 'No se ha podido actualizar el perfil',
  'pf.fotkaNahrana': 'Foto subida.',
  'pf.fotkaChyba': 'No se ha podido subir la imagen',
  'pf.fotkaVelka': 'La imagen es demasiado grande (máx. 5 MB)',
  'pf.oznameniUlozeno': 'Ajustes de notificaciones guardados.',
  'pf.oznameniChyba': 'No se han podido guardar los ajustes',
  'pf.zruseno': 'Tu perfil se ha eliminado',
  'pf.zruseniChyba': 'No se ha podido eliminar el perfil',
  'pf.zruseniPotvrzeni': '¿Seguro que quieres eliminar tu perfil? Esto no se puede deshacer y se borrarán todos tus datos.',
  'pf.urlFacebook': 'La dirección de Facebook tiene que empezar por https://',
  'pf.urlInstagram': 'La dirección de Instagram tiene que empezar por https://',
  'pf.urlLinkedin': 'La dirección de LinkedIn tiene que empezar por https://',
  'pf.ukladam': 'Guardando…',
  'pf.ulozitOznameni': 'Guardar los ajustes de notificaciones',
  'pf.oznameniZpravy': 'Mensajes privados',
  'pf.oznameniAdmin': 'Mensaje nuevo de la administración',
  'pf.oznameniUzivatel': 'Mensaje nuevo de otra persona',
  'pf.oznameniPodpora': 'Publicación nueva en Apoyo mutuo',
  'pf.oznameniNabidky': 'Ofertas y peticiones',

  // odznaky
  'pf.odznakAdmin': 'Administración',
  'pf.odznakPravnik': 'Abogacía',
  'pf.odznakSpecialista': 'Profesional verificado',
  'pf.odznakClen': 'Miembro verificado de la comunidad',
  'pf.odznakPomocnik': 'Ayuda activa',
  'pf.odznakDuveryhodny': 'Persona de confianza',

  // ── galerie ───────────────────────────────────────────────────────────────
  'gal.pridano': 'Foto añadida a la galería.',
  'gal.smazano': 'Foto eliminada',
  'gal.hesloKratke': 'La contraseña de la galería tiene que tener al menos 4 caracteres',
  'gal.nahraniChyba': 'No se ha podido subir la foto',
  'gal.mazaniChyba': 'No se ha podido eliminar la foto',
  'gal.souborVelky': 'El archivo es demasiado grande (máx. 5 MB)',
  'gal.ulozitNastaveni': 'Guardar los ajustes',
  'gal.hesloPopis': 'Quien la visite tendrá que escribir esta contraseña para ver la galería.',
  'gal.pridat': 'Añadir una foto o un vídeo',
  'gal.prazdna': 'Todavía no hay fotos en la galería',

  // ── moje cesta ────────────────────────────────────────────────────────────
  'cesta.kdeJsem': '¿Dónde estoy ahora?',
  'cesta.popis': 'Comparte tu etapa de transición si quieres, o guárdala solo para ti.',
  'cesta.soukroma': 'Tu etapa es privada',
  'cesta.viditelna': 'Tu etapa es visible para las demás personas',
  'cesta.jenTy': 'Solo tú ves tu etapa',
  'cesta.mohouNajit': 'Otras personas pueden encontrarte con «Buscar personas en una etapa parecida»',
  'cesta.poznamka': 'Nota personal',
  'cesta.volitelna': '(opcional)',
  'cesta.poznamkaPriklad': 'Lo que quieras compartir o recordar…',
  'cesta.najitPodobne': 'Buscar personas en una etapa parecida',
  'cesta.hledam': 'Buscando…',
  'cesta.ulozit': 'Guardar mi camino',
  'cesta.ulozeno': 'Tu camino se ha guardado.',
  'cesta.vyberteFazi': 'Elige una etapa',
  'cesta.chyba': 'No se ha podido guardar',

  'pf.socialniSite': 'Redes sociales',
  'pf.avatarFoto': 'Avatar / foto de perfil',
  'pf.nahratProfilni': 'Subir foto de perfil',
  'pf.zrusitProfil': 'Eliminar el perfil',
  'pf.nastaveniOznameni': 'Ajustes de notificaciones',
  'pf.nastaveniOznameniPopis': 'Elige de qué quieres recibir notificaciones.',
  'gal.overEmail': 'Para subir fotos primero tienes que verificar tu correo.',
  'cesta.coMeCeka': 'Qué me espera',

  // ── zprávy ────────────────────────────────────────────────────────────────
  'zpr.titulek': 'Mensajes',
  'zpr.hledatUzivatele': 'Buscar a una persona…',
  'zpr.zadneKonverzace': 'Todavía no hay conversaciones',
  'zpr.vyhledejteVyse': 'Busca a una persona arriba',
  'zpr.vyberteKonverzaci': 'Elige una conversación o busca a alguien',
  'zpr.napisteZpravu': 'Escribe un mensaje…',
  'zpr.nahravam': 'Grabando…',
  'zpr.prilozitObrazek': 'Adjuntar una imagen',
  'zpr.hlasovaZprava': 'Mensaje de voz',
  'zpr.zastavitNahravani': 'Parar la grabación',
  'zpr.obrazek': 'Imagen',
  'zpr.overteEmail': 'Para enviar mensajes, verifica tu correo.',
  'zpr.profil': 'Perfil',

  // šifrování
  'zpr.sifrovanaZprava': 'Mensaje cifrado',
  'zpr.odemkniNahore': 'Mensaje cifrado — desbloquea tus mensajes arriba.',
  'gal.soukromiGalerie': 'Privacidad de la galería',
  'gal.verejnaGalerie': 'Galería pública',
  'zpr.nelzeOtevrit': 'No se ha podido abrir este mensaje cifrado.',

  // hlášky
  'zpr.uzivatelNenalezen': 'No se ha encontrado a esa persona',
  'zpr.prijemceNenalezen': 'No se ha encontrado a quien lo recibe',
  'zpr.prihlasteZnovu': 'Vuelve a iniciar sesión (tu sesión ha caducado)',
  'zpr.serverNedostupny': 'No se llega al servidor. Comprueba que el backend está en marcha.',
  'zpr.chybaOdeslani': 'No se ha podido enviar',
  'zpr.souborVelky': 'El archivo es demasiado grande (máx. 5 MB)',
  'zpr.formatNepodporovan': 'Tipo de archivo no admitido',
  'zpr.mediaOdeslano': 'Archivo enviado',
  'zpr.mikrofon': 'El micrófono no está disponible',
  'zpr.hlasovkaOdeslana': 'Mensaje de voz enviado',
  'zpr.hlasovkaChyba': (p) => `No se ha podido enviar el mensaje de voz: ${p.detail}`,
  'zpr.smazano': 'Conversación eliminada',
  'zpr.smazaniChyba': 'No se ha podido eliminar la conversación',
  'zpr.smazaniPotvrzeni': 'Desaparece de tu lista, con los archivos adjuntos. La otra persona conserva su copia: '
      + 'el mensaje se borra del servidor del todo solo cuando lo borráis las dos.',

  // ── šifrování zpráv ───────────────────────────────────────────────────────
  'sif.zadejHeslo': 'Escribe tu contraseña.',
  'sif.zapnuto': 'El cifrado está activado.',
  'sif.odemceno': 'Tus mensajes están desbloqueados.',
  'sif.hesloNesedi': 'Esa contraseña no es correcta.',
  'sif.prohlizecNeumi': 'Este navegador no admite el cifrado que usa Bloom. Puedes escribir mensajes igualmente, '
      + 'pero no irán cifrados de extremo a extremo.',
  'sif.noveJsouSifrovane': 'Los mensajes nuevos van cifrados. La clave la tienes solo tú: el servidor no puede leerlos.',
  'sif.odemkniZpravy': 'Desbloquea tus mensajes',
  'sif.odemkniPopis': 'La clave vive solo en la memoria de esta pestaña, así que al recargar la página hace falta la contraseña de nuevo. '
      + 'No podemos guardarla en ningún sitio: entonces ya no sería un cifrado que controlas solo tú.',
  'sif.zapniSifrovani': 'Activar el cifrado de mensajes',
  'sif.zapniPopis': 'Los mensajes nuevos se cifran aquí mismo, en tu dispositivo. El servidor solo recibe caracteres ilegibles '
      + 'y no puede leerlos, ni aunque lo pidiera un juzgado.',
  'sif.pozorA': 'Ojo: la clave se abre con tu contraseña.',
  'sif.pozorTucne': 'Si la olvidas, nadie podrá leer tus mensajes cifrados',
  'sif.pozorB': ' — nosotras tampoco. De eso se trata, pero significa que necesitas guardarla en algún sitio.',
  'sif.mobilA': 'Activarlo cambia también cómo inicias sesión: tu contraseña deja de llegar al servidor, solo se envía su huella.',
  'sif.mobilTucne': 'La aplicación móvil antigua de Bloom no podrá entonces iniciar sesión en esta cuenta',
  'sif.mobilB': ' hasta que la actualicemos. En la web todo sigue funcionando.',
  'sif.zapnoutSifrovani': 'Activar el cifrado',
  'sif.odemknout': 'Desbloquear',
  'sif.tvojeHeslo': 'Tu contraseña de Bloom',
  'sif.prilohaZamcena': 'Archivo cifrado — desbloquea tus mensajes arriba.',
  'sif.prilohaChyba': 'No se ha podido abrir el archivo.',
  'sif.priloha': 'Archivo del mensaje',

  // ── v mém okolí ───────────────────────────────────────────────────────────
  'okoli.vaseLokalita': 'Tu ubicación',
  'okoli.nastavtePolohu': 'Indica dónde estás para ver resultados cercanos',
  'okoli.vyberteVyse': 'Elige una ubicación arriba para ver ofertas y profesionales cerca de ti',
  'okoli.zadniOdbornici': 'Todavía no hay profesionales registrados en esta zona',
  'okoli.zadneNabidky': 'Todavía no hay ofertas en esta zona',
  'okoli.zadniClenove': 'Todavía no hay nadie de la comunidad en esta zona',
  'okoli.vytvoritNabidku': 'Crear una oferta',

  // ── hledání ───────────────────────────────────────────────────────────────
  'hled.hledam': 'Buscando:',
  'hled.vysledkyPro': 'Resultados de la búsqueda:',
  'hled.nicPro': 'No hemos encontrado nada de:',
  'hled.nicZkuste': 'No hemos encontrado nada. Prueba con otra palabra.',
  'hled.zkratte': 'Prueba con una frase más corta o con otra palabra.',
  'hled.zadejte': 'Escribe lo que buscas y pulsa Intro',
  'hled.priklady': 'Por ejemplo: FFS, hormonas, nombre, médico, DNI, cirugía…',
  'hled.uzivatele': 'Personas',
  'hled.odbornici': 'Profesionales trans-friendly',
  'hled.clanky': 'Ayuda legal – artículos',
  'hled.otazky': 'Preguntas de la comunidad',
  'hled.nabidky': 'Ofertas de ayuda',
  'hled.prispevky': 'Publicaciones',
  'hled.recenze': 'Valoraciones de profesionales',

  // ── profil člena ──────────────────────────────────────────────────────────
  'up.nenalezen': 'No se ha encontrado a esa persona',
  'up.oMne': 'Sobre',
  'up.clenOd': 'En Bloom desde',
  'up.odznakSpravce': 'Administración',
  'up.odznakPravnik': 'Abogacía',
  'up.odznakOdbornik': 'Profesional verificado',
  'up.odznakPravnikOvereny': 'Abogacía verificada',
  'up.odznakClen': 'Miembro verificado',
  'up.odznakPomocnik': 'Ayuda activa',
  'up.odznakDuveryhodny': 'De confianza',

  // ── zásady komunity ───────────────────────────────────────────────────────
  'kom.zpet': 'Volver a Bloom',
  'kom.oProjektu': 'Bloom nació como un espacio comunitario seguro para las personas trans de Chequia: un lugar '
      + 'para compartir experiencias, encontrar apoyo, dar con profesionales y conocer a otra gente. '
      + 'El proyecto lo lleva la comunidad de forma voluntaria. Sus objetivos son la discreción, la privacidad y la ayuda mutua.',
  'kom.kontaktText': '¿Tienes dudas o necesitas ayuda? Escríbenos. Intentamos responder lo antes posible.',
  'kom.respekt': 'Nos respetamos',
  'kom.respektPopis': 'Nos dirigimos a cada persona por el nombre y los pronombres que usa. Respetamos caminos y experiencias distintos: '
      + 'no hay una forma correcta o incorrecta de ser trans.',
  'kom.soukromi': 'Cuidamos la privacidad de las demás',
  'kom.soukromiPopis': 'Lo que se comparte en Bloom se queda en Bloom. No compartas información sobre otras personas sin '
      + 'su consentimiento. Respetamos el anonimato.',
  'kom.pomahame': 'Nos ayudamos',
  'kom.pomahamePopis': 'Bloom va de apoyo mutuo. Compartimos experiencias, nos echamos una mano y construimos un espacio seguro '
      + 'para quien busca compañía o información.',
  'kom.obtezovani': 'No toleramos el acoso',
  'kom.obtezovaniPopis': 'El acoso, el hostigamiento o los comentarios hostiles no tienen sitio en Bloom. Si algo te incomoda, '
      + 'escribe a la administración.',
  'kom.spam': 'Nada de spam ni publicidad',
  'kom.spamPopis': 'Bloom no es un mercado. No publiques publicidad no solicitada ni contenido comercial. '
      + 'Las ofertas y peticiones van en Apoyo mutuo.',
  'kom.prostor': 'Un espacio para cada etapa',
  'kom.prostorPopis': 'No estás sola, estés en el punto del camino en el que estés. Damos la bienvenida a quien se plantea '
      + 'la transición, a quien está en medio y a quien ya la ha pasado, y tomamos cada camino como es.',
  'kom.dataPopis': 'Bloom recoge solo los datos que la plataforma necesita para funcionar: tu correo, tu apodo y el perfil '
      + 'que creas tú.',
  'kom.dataTretiStrany': 'Tus datos no se comparten con terceros. La plataforma no usa tecnología de seguimiento ni redes publicitarias.',
  'kom.dataSmazani': 'Tienes derecho a pedir que se borren tu cuenta y todos los datos ligados a ella. Escribe a la administración.',

  'okoli.podtitulek': 'Encuentra personas de la comunidad, servicios y profesionales cerca de ti',
  'okoli.cleneVOkoli': (p) => `Personas de la comunidad cerca de ${p.misto}`,
  'okoli.nabidkyVOkoli': (p) => `Ofertas de ayuda cerca de ${p.misto}`,
  'okoli.odborniciVOkoli': (p) => `Profesionales cerca de ${p.misto}`,
  'hled.zobrazitVice': 'Ver más',
  'kom.titulek': 'Normas de la comunidad',
  'kom.podtitulek': 'Un espacio seguro para todo el mundo',
  'kom.jakNahlasit': 'Cómo informar de un problema',
  'kom.jakNahlasitPopis': 'Si te encuentras con un comportamiento inadecuado, tienes dos opciones: usar el botón «Denunciar a esta persona» '
      + 'en su perfil, o escribir a la administración.',
  'kom.duverne': 'Tu denuncia es confidencial.',
  'kom.ochranaSoukromi': 'Privacidad',
  'obecne.zpetKratce': 'Volver',

  // ── průvodce fází ─────────────────────────────────────────────────────────
  'cesta.nikdoNesdili': 'Todavía nadie más de la comunidad comparte esta etapa públicamente.',
  'cesta.poznamkaFazePriklad': 'Lo que quieras compartir o recordar de esta etapa…',
  'pruvodce.fazeNenalezena': 'Etapa no encontrada',
  'pruvodce.pripravujeme': 'Todavía estamos preparando esta parte.',
  'pruvodce.krokyJenTy': 'Los pasos que marcas los ves solo tú.',
  'pruvodce.nastavitFazi': 'Marcar como mi etapa actual',
  'pruvodce.fazeNastavena': 'Marcada como tu etapa actual',
  'pruvodce.chyba': 'No se ha podido guardar, inténtalo otra vez',
  'pruvodce.kroku': 'pasos',
  'pruvodce.odborniku': (p) => `${p.pocet === 1 ? 'profesional' : 'profesionales'} para esta etapa`,
  'pruvodce.pribehu': (p) => `${p.pocet === 1 ? 'experiencia' : 'experiencias'} de personas en esta etapa`,

  // ── obnovení hesla ────────────────────────────────────────────────────────
  'reset.titulek': 'Restablecer la contraseña',
  'reset.popis': 'Escribe una contraseña nueva para tu cuenta de Bloom.',
  'reset.noveHeslo': 'Nueva contraseña',
  'reset.noveHesloPriklad': 'Escribe una contraseña nueva',
  'reset.potvrdit': 'Confirma la nueva contraseña',
  'reset.nastavit': 'Guardar la nueva contraseña',
  'reset.ukladam': 'Guardando…',
  'reset.hotovo': 'Tu contraseña se ha cambiado. Ya puedes iniciar sesión.',
  'reset.neplatnyOdkaz': 'Ese enlace para restablecer la contraseña no es válido.',
  'reset.odkazVyprsel': 'El enlace ha caducado o no es válido. Pide uno nuevo.',
  'reset.chyba': 'No se ha podido restablecer la contraseña.',
  'reset.neshoda': 'Las contraseñas no coinciden.',
  'reset.ztratiPristup': 'perderá el acceso',

  'cesta.volitelne': 'Esto es totalmente opcional. Comparte tu etapa de transición si quieres, o guárdala solo para ti. '
      + 'También puedes encontrar a gente en un punto parecido del camino.',
  'cesta.hledatVeFazi': 'Buscar personas en esta etapa:',
  'cesta.jenVerejne': '(solo quien la comparte públicamente)',
  'pruvodce.zpetNaCestu': 'Volver a Mi camino',
  'pruvodce.tadyJsi': 'Aquí estás ahora',
  'reset.prejitNaPrihlaseni': 'Ir al inicio de sesión',
  'reset.sifrovaniVarovani': 'Si tienes el cifrado de mensajes activado: al restablecer la contraseña ya no podrás llegar a tus '
      + 'mensajes cifrados antiguos. Su clave se abre con la contraseña original, y aquí nadie la conoce, así que no se '
      + 'puede volver a envolver. Los mensajes nuevos se podrán seguir cifrando; los antiguos ya no se leerán, tampoco por nosotras.',

  // ── veřejná úvodní stránka ────────────────────────────────────────────────
  'uvod.prihlasit': 'Iniciar sesión',
  'uvod.vytvoritUcet': 'Crear una cuenta',
  'uvod.uzMamUcet': 'Ya tengo cuenta',
  'uvod.nadpis': 'Un espacio seguro para la comunidad trans',
  'uvod.podnadpis': 'Bloom es un lugar privado donde puedes hablar con libertad, encontrar profesionales trans-friendly '
      + 'y hacer tu transición entre gente que sabe de qué va.',
  'uvod.zdarma': 'Registrarse es gratis. El contenido de Bloom se abre solo al iniciar sesión.',
  'uvod.kCemuJe': 'Para qué sirve Bloom',
  'uvod.kCemuJe1': 'Buscar información sobre la transición en Chequia suele significar ir dando clics por foros '
      + 'dispersos, artículos desfasados y enlaces de los que no sabes si fiarte. Y a muchas preguntas '
      + 'responde mejor alguien que ha pasado por ello.',
  'uvod.kCemuJe2': 'Bloom lo reúne todo en un sitio: profesionales con quienes la comunidad tiene buena experiencia, una guía '
      + 'por las etapas de la transición, ayuda legal y, sobre todo, gente a la que escribir.',
  'uvod.kCemuJe3': 'Y como son cosas que nadie quiere contarle a todo internet, Bloom está hecho desde '
      + 'el principio para que desde fuera no se vea absolutamente nada.',
  'uvod.coNajdes': 'Qué encontrarás en Bloom',
  'uvod.coNajdesPopis': 'Ocho partes que se apoyan unas en otras: de la ayuda práctica a las experiencias compartidas.',
  'uvod.soukromiZaklad': 'La privacidad no es un añadido, es la base',
  'uvod.jakZabezpeceny': 'Cómo está protegido Bloom',
  'uvod.zabezpeceniPopis': 'Los datos de las personas no se venden ni se analizan. En Bloom no corre ningún rastreo publicitario '
      + 'ni analítico: ningún script ajeno se entera de nada sobre ti.',
  'uvod.coNeumi': 'Lo que Bloom no puede hacer',
  'uvod.metadataTucne': 'quién escribe a quién y cuándo',
  'uvod.coNeumiA': 'El servidor siempre sabe',
  'uvod.coNeumiB': ' — sin eso no podría entregar el mensaje. El cifrado de extremo a extremo no oculta estos '
      + 'metadatos, y Signal tampoco. Los perfiles no se pueden cifrar, porque el servidor tiene que mostrarlos '
      + 'a las demás personas. Y como Bloom es una aplicación web, descarga su código de cifrado de nuestro servidor '
      + 'cada vez que la abres: quien se hiciera con el servidor podría, en teoría, servir uno modificado. '
      + 'Contra eso solo protege una aplicación firmada de una tienda.',
  'uvod.pridejSe': 'Únete',
  'uvod.pridejSePopis': 'Basta con un apodo y un correo: no tienes que dar tu nombre legal en ningún sitio. Lo que escribas '
      + 'sobre ti depende de ti, y puedes cambiarlo o borrarlo cuando quieras.',

  // co Bloom nabízí
  'uvod.karta.podpora': 'Ofrece ayuda o pídela: desde acompañar a una consulta hasta prestar ropa o un '
      + '«necesito hablar con alguien».',
  'uvod.karta.odbornici': 'Sexología, endocrinología, cirugía, psicoterapia y también peluquería. Con mapa, contactos y las experiencias de otras personas.',
  'uvod.karta.pravo': 'Cambio de nombre, documentos oficiales, trabajo, estudios. Responde quien conoce el terreno.',
  'uvod.karta.pruvodce': 'Qué te espera en cada paso, de las primeras preguntas a las cirugías. Con enlaces a fuentes verificadas y a profesionales.',
  'uvod.karta.zpravy': 'Escribe a cualquier persona de la comunidad. Los mensajes y los archivos se guardan cifrados en el servidor.',
  'uvod.karta.zkusenosti': 'Historias reales de quien ha pasado por ello. Sin censura y sin adornos.',
  'uvod.karta.aktuality': 'Qué pasa en torno a los temas trans en Chequia: cambios legales, eventos, novedades de la comunidad.',
  'uvod.karta.okoli': 'Quién está cerca de ti. Para que sepas que no estás sola, ni siquiera en una ciudad pequeña.',

  // zabezpečení
  'uvod.bezp.zvencinic': 'Desde fuera no se ve absolutamente nada',
  'uvod.bezp.zvencinicText': 'Los perfiles, las historias, las fotos, las ofertas y las imágenes de las publicaciones piden iniciar sesión. Sin cuenta, el '
      + 'servidor no entrega ningún dato sobre las personas, ni siquiera a los buscadores.',
  'uvod.bezp.hesla': 'Nadie conoce tu contraseña',
  'uvod.bezp.heslaText': 'Solo se guarda un hash bcrypt, del que no se puede calcular la contraseña original. Ni siquiera la '
      + 'administración ve tu contraseña ni puede enviártela: solo puede dejarte poner una nueva.',
  'uvod.bezp.sifrovani': 'Mensajes cifrados de ti a la otra persona',
  'uvod.bezp.sifrovaniText': 'Cuando activas el cifrado de extremo a extremo, el texto y los archivos se cifran en tu propio navegador. '
      + 'La clave se abre con tu contraseña y nunca sale de tu dispositivo: el servidor recibe solo '
      + 'caracteres ilegibles y no puede leerlos, ni aunque lo pidiera un juzgado. Sin cifrado, los mensajes están al menos '
      + 'cifrados en el disco del servidor.',
  'uvod.bezp.kontakty': 'Tus datos de contacto siguen siendo tuyos',
  'uvod.bezp.kontaktyText': 'Tu correo y tu teléfono nunca se devuelven a otras personas. Tu etapa de transición es privada hasta '
      + 'que la publiques, y los pasos que marcas en la Guía los ves solo tú.',
  'uvod.bezp.smazane': 'Lo borrado está borrado de verdad',
  'uvod.bezp.smazaneText': 'Puedes borrar una conversación cuando quieras. Cuando la borran las dos partes, desaparece del servidor '
      + 'para siempre, con los archivos adjuntos.',
  'uvod.bezp.server': 'Servidor propio en Europa',
  'uvod.bezp.serverText': 'Bloom corre en un servidor propio en la Unión Europea, solo por HTTPS. La base de datos no es accesible '
      + 'desde internet. Las copias de seguridad salen cifradas a otro almacenamiento y su restauración está probada.',

  'uvod.karta.pruvodceNazev': 'Guía por la transición',
  'uvod.karta.zpravyNazev': 'Mensajes privados',

  // ── vzájemná podpora ──────────────────────────────────────────────────────
  'pod.podtitulek': 'Ofrece lo que sabes hacer y recibe ayuda de otras personas de la comunidad',
  'pod.vse': 'Todo',
  'pod.nabidky': 'Ofertas',
  'pod.poptavky': 'Peticiones',
  'pod.nabidka': 'Oferta',
  'pod.poptavka': 'Petición',
  'pod.celaCR': 'Toda Chequia',
  'pod.celySvet': 'Todo el mundo',
  'pod.cesko': 'Chequia',
  'pod.svet': 'Mundo',
  'pod.vsechnyTypy': 'Todas las categorías',
  'pod.moje': (p) => `Mías (${p.pocet})`,
  'pod.pridat': 'Añadir',
  'pod.overEmail': 'Verifica tu correo para poder añadir una oferta',
  'pod.novaPoptavka': 'Nueva petición',
  'pod.novaNabidka': 'Nueva oferta',
  'pod.popisPoptavky': 'Escribe qué buscas y qué ofreces a cambio.',
  'pod.popisNabidky': 'Ofrece lo que sabes hacer a otras personas de la comunidad.',
  'pod.typPrispevku': 'Tipo de publicación',
  'pod.volitelne': '(opcional)',
  'pod.coNabizim': 'Qué ofrezco',
  'pod.coNabizimP': 'Qué ofrezco *',
  'pod.coHledamP': 'Qué busco *',
  'pod.coHledamVymenou': 'Qué busco a cambio',
  'pod.priklOffer': 'p. ej. cocinar, peinados, traducción…',
  'pod.priklNeed': 'p. ej. masajes, fotografía…',
  'pod.poptavkaSeZobrazi': 'Tu petición aparecerá en la pestaña Peticiones.',
  'pod.nabidkaSeZobrazi': 'Si lo rellenas, tu oferta aparecerá también en la pestaña Peticiones.',
  'pod.popis': 'Descripción',
  'pod.popisPriklad': 'Una descripción más detallada…',
  'pod.oblast': 'Zona',
  'pod.lokalita': 'Ubicación',
  'pod.nechciUvadet': 'Prefiero no decirlo',
  'pod.kategorie': 'Categoría',
  'pod.ostatni': 'Otros',
  'pod.pridatPoptavku': 'Añadir la petición',
  'pod.pridatNabidku': 'Añadir la oferta',
  'pod.odpovedetNaPrispevek': 'Responder a la publicación',
  'pod.napisteAutorovi': 'Escribe un mensaje privado a quien la ha publicado.',
  'pod.od': (p) => `De: ${p.kdo}`,
  'pod.odeslatZpravu': 'Enviar el mensaje',
  'pod.konceptOdpovedi': (p) => `¡Hola! Me interesa tu ${p.co} «${p.nazev}». `,
  'pod.konceptPoptavka': 'petición',
  'pod.konceptNabidka': 'oferta',
  'pod.zadneMoje': 'Todavía no tienes publicaciones',
  'pod.zadneNalezeny': 'No se han encontrado publicaciones',
  'pod.vytvortePrvni': 'Crea tu primera oferta o petición',
  'pod.zkusteFiltry': 'Prueba a cambiar los filtros o añade una publicación nueva',
  'pod.expirovano': 'Caducada',
  'pod.hledam': 'Busco',
  'pod.hledamCo': (p) => `Busco: ${p.co}`,
  'pod.nabizimCo': (p) => `Ofrezco: ${p.co}`,
  'pod.expirovala': 'Esta oferta ha caducado. Escribe a la administración para renovarla.',
  'pod.odpovedet': 'Responder',
  'pod.upravitPrispevek': 'Editar la publicación',
  'pod.upravtePrispevek': 'Edita tu oferta o tu petición.',
  'pod.nabizimP': 'Ofrezco *',
  'pod.hledamPotrebuji': 'Busco / necesito',
  'pod.coNabizitePriklad': 'Qué ofreces…',
  'pod.coHledatePriklad': 'Qué buscas…',
  'pod.ulozitZmeny': 'Guardar los cambios',
  'pod.vytvorenoPoptavka': 'Petición creada.',
  'pod.vytvorenoNabidka': 'Oferta creada.',
  'pod.chybaVytvorit': 'No se ha podido crear la publicación',
  'pod.opravduSmazat': '¿Eliminar esta oferta?',
  'pod.smazano': 'Eliminado',
  'pod.chybaSmazat': 'No se ha podido eliminar',
  'pod.aktualizovano': 'Publicación actualizada.',
  'pod.chybaUlozit': 'No se ha podido guardar',
  'pod.zpravaOdeslana': 'Mensaje enviado.',
  'pod.chybaOdeslat': 'No se ha podido enviar el mensaje',
  'obecne.hledatPriklad': 'Buscar…',
  'obecne.upravit': 'Editar',

  // ── odborníci ─────────────────────────────────────────────────────────────
  'odb.podtitulek': 'Encuentra profesionales verificados que pueden ayudarte en tu camino',
  'odb.hledatPriklad': 'Buscar por nombre o ciudad…',
  'odb.vsechnyObory': 'Todas las especialidades',
  'odb.radit': 'Ordenar:',
  'odb.vychozi': 'Por defecto',
  'odb.nejvyssiHodnoceni': '★ Mejor valorados',
  'odb.nejnizsiHodnoceni': '★ Peor valorados',
  'odb.zadniNalezeni': 'No se han encontrado profesionales',
  'odb.zkusteFiltry': 'Prueba a cambiar los filtros',
  'odb.recenzi': (p) => (p.pocet === 1 ? 'valoración' : 'valoraciones'),
  'odb.dostupnyV': 'Disponible en:',
  'odb.otevritVMapach': 'Abrir en el mapa',
  'odb.pridatRecenzi': 'Añadir una valoración',
  'odb.ohodnotte': 'Valora tu experiencia con esta persona.',
  'odb.vaseHodnoceni': 'Tu valoración *',
  'odb.popisZkusenosti': 'Describe tu experiencia',
  'odb.popisteZkusenost': 'Describe tu experiencia…',
  'odb.odeslatRecenzi': 'Enviar la valoración',
  'odb.recenze': (p) => `Valoraciones (${p.pocet})`,
  'odb.zadneRecenze': 'Todavía no hay valoraciones. Sé la primera persona.',
  'odb.vyberteOdbornika': 'Elige a un profesional para ver sus datos y el mapa',
  'odb.pridatOdbornika': 'Añadir profesional',
  'odb.pridejteOdbornika': 'Añade a la lista un nuevo profesional verificado.',
  'odb.navrhnout': 'Sugerir profesional',
  'odb.navrhnetePopis': 'Sugiere a un profesional para que lo apruebe la administración.',
  'odb.navrhVysvetleni': 'Tu sugerencia se enviará a la administración. Una vez aprobada, aparecerá en la lista.',
  'odb.overEmail': 'Verifica tu correo para sugerir a un profesional',
  'odb.jmeno': 'Nombre *',
  'odb.kategorie': 'Categoría *',
  'odb.popis': 'Descripción',
  'odb.popisPriklad': 'Especialidad, experiencia…',
  'odb.adresa': 'Dirección *',
  'odb.mesto': 'Ciudad *',
  'odb.kraj': 'Región',
  'odb.vyber': 'Elige',
  'odb.stat': 'País',
  'odb.cesko': 'Chequia',
  'odb.telefon': 'Teléfono',
  'odb.web': 'Web',
  'odb.odesilam': 'Enviando…',
  'odb.odeslatKeSchvaleni': 'Enviar para aprobación',
  'odb.recenzePridana': 'Valoración añadida.',
  'odb.chybaRecenze': 'No se ha podido añadir la valoración',
  'odb.odeslanKeSchvaleni': 'El profesional se ha enviado para aprobación.',
  'odb.chybaOdeslat': 'No se ha podido enviar',
  'odb.pridan': 'Profesional añadido.',
  'odb.chybaPridat': 'No se ha podido añadir',
  'odb.polozitOtazku': 'Hacer una pregunta',
  'odb.novaOtazka': 'Nueva pregunta para profesionales',
  'odb.naCoSeZeptat': '¿Qué quieres preguntar a los profesionales?',

  // ── právní poradna ────────────────────────────────────────────────────────
  'prav.podtitulek': 'Información y apoyo para la comunidad trans',
  'prav.zpetNaPoradnu': 'Volver a Ayuda legal',
  'prav.clankyAPruvodci': 'Artículos y guías',
  'prav.pridatClanek': 'Añadir un artículo',
  'prav.novyClanek': 'Nuevo artículo',
  'prav.vytvorteClanek': 'Escribe un artículo nuevo para la sección legal.',
  'prav.nazev': 'Título *',
  'prav.kategorie': 'Categoría',
  'prav.publikovatIhned': 'Publicar ya',
  'prav.publikovano': 'Publicado',
  'prav.obsah': 'Contenido *',
  'prav.obsahPriklad': 'Contenido del artículo…',
  'prav.zadneClanky': 'No hay artículos en esta categoría',
  'prav.skryto': 'Oculto',
  'prav.skryt': 'Ocultar',
  'prav.publikovat': 'Publicar',
  'prav.upravitClanek': 'Editar el artículo',
  'prav.upravteObsah': 'Edita el contenido de este artículo.',
  'prav.clanekPridan': 'Artículo añadido.',
  'prav.chybaPridat': 'No se ha podido añadir el artículo',
  'prav.clanekUpraven': 'Artículo actualizado.',
  'prav.opravduSmazat': '¿Eliminar este artículo?',
  'prav.chybaStav': 'No se ha podido cambiar el estado',
  'prav.pridatOtazku': 'Añadir una pregunta',
  'prav.novaOtazka': 'Nueva pregunta',
  'prav.naCoSeZeptat': '¿Qué quieres preguntar?',
  'obecne.vse': 'Todo',
  // ── aktuality ─────────────────────────────────────────────────────────────
  'akt.podtitulek': 'Novedades del mundo trans',
  'akt.prehratVideo': 'Reproducir el vídeo',
  'akt.obrazekVClanku': 'Imagen del artículo',
  'akt.clanekNenalezen': 'Artículo no encontrado',
  'akt.zpetNaAktuality': 'Volver a Actualidad',
  'akt.autor': (p) => `Autoría: ${p.kdo}`,
  'akt.osobniPribeh': 'Experiencia personal',
  'akt.upravitClanek': 'Editar el artículo',
  'akt.komentare': (p) => `Comentarios (${p.pocet})`,
  'akt.zadneKomentare': 'Todavía no hay comentarios. Sé la primera persona.',
  'akt.pridatKomentar': 'Añadir un comentario…',
  'akt.proKomentovaniOverte': 'Verifica tu correo para comentar.',
  'akt.profil': 'Perfil',
  'akt.prihlasteSeProKomentovani': 'Inicia sesión para comentar.',
  'akt.upravteObsah': 'Edita el contenido de este artículo.',
  'akt.nadpisP': 'Titular *',
  'akt.nadpis': 'Titular',
  'akt.obsahP': 'Contenido *',
  'akt.textClanku': 'Texto del artículo…',
  'akt.obrazekUrlNeboSoubor': 'Imagen (dirección o archivo)',
  'akt.videoUrlNeboSoubor': 'Vídeo (dirección o archivo)',
  'akt.ukladam': 'Guardando…',
  'akt.novaAktualita': 'Nueva noticia',
  'akt.sdiletPribeh': 'Compartir una experiencia',
  'akt.vytvoritAktualitu': 'Escribir una noticia',
  'akt.sdiletZkusenost': 'Compartir una experiencia',
  'akt.napisteAktualitu': 'Escribe una noticia nueva para la comunidad.',
  'akt.podelteSe': 'Comparte tu experiencia con la comunidad.',
  'akt.obrazek': 'Imagen',
  'akt.nahratObrazek': 'Subir una imagen…',
  'akt.nahratVideo': 'Subir un vídeo…',
  'akt.neboUrl': 'o una dirección:',
  'akt.textAktuality': 'Texto de la noticia…',
  'akt.sdilejtePribeh': 'Comparte tu historia o tu experiencia con la comunidad…',
  'akt.nahravam': 'Subiendo…',
  'akt.publikovat': 'Publicar',
  'akt.zkusenostiTucne': 'Experiencias personales de la comunidad.',
  'akt.zkusenostiPopis': 'Esta sección es para compartir experiencias e historias de vida. Las publicaciones pueden llevar texto, imágenes o vídeo.',
  'akt.sdiletSvujPribeh': 'Compartir mi experiencia',
  'akt.zadneAktuality': 'No hay noticias',
  'akt.zadneVKategorii': 'Todavía no hay nada en esta categoría',
  'akt.publikovan': 'Publicación publicada.',
  'akt.chybaPublikovat': 'No se ha podido publicar',
  'akt.opravduSmazat': '¿Eliminar esta publicación?',
  'akt.chyba': 'Algo ha salido mal',
  'akt.chybaKomentar': 'No se ha podido añadir el comentario',
  'akt.chybaSmazatKomentar': 'No se ha podido eliminar el comentario',
  'akt.aktualizovan': 'Publicación actualizada.',
  'obecne.smazat': 'Eliminar',

  // ── fáze tranzice ─────────────────────────────────────────────────────────
  'faze.thinking': 'Me planteo la transición',
  'faze.thinking.popis': 'Estoy averiguando quién soy y cuál es mi camino.',
  'faze.research': 'Busco información',
  'faze.research.popis': 'Leo, pregunto, busco fuentes y comunidad.',
  'faze.therapist': 'Primera visita a terapia',
  'faze.therapist.popis': 'Hablo de mi camino con una persona profesional.',
  'faze.hormones': 'Tratamiento hormonal',
  'faze.hormones.popis': 'Empiezo o sigo con la terapia hormonal.',
  'faze.documents': 'Cambio de documentos',
  'faze.documents.popis': 'Trabajo en el cambio legal de nombre o de sexo.',
  'faze.cosmetic': 'Aspecto y cuidado personal',
  'faze.cosmetic.popis': 'Trabajo en mi aspecto: pelo, maquillaje, estilo.',
  'faze.surgery-thinking': 'Me planteo operarme',
  'faze.surgery-thinking.popis': 'Estoy valorando las opciones quirúrgicas.',
  'faze.surgery': 'Después de las cirugías',
  'faze.surgery.popis': 'He pasado por una o más cirugías.',
  'faze.stable': 'Etapa estable',
  'faze.stable.popis': 'Estoy donde quiero estar y vivo mi vida.',
  'faze.individual': 'Mi propio camino',
  'faze.individual.popis': 'Mi camino no encaja en ninguna casilla, y está bien así.',

  // ── zkušenosti komunity ───────────────────────────────────────────────────
  'zk.podtitulek': 'Aquí se comparten las historias.',
  'zk.pribehNenalezen': 'Experiencia no encontrada',
  'zk.zpetNaPribehy': 'Volver a las experiencias',
  'zk.komunita': 'La comunidad',
  'zk.pribeh': 'Experiencia',
  'zk.upravitPribeh': 'Editar la experiencia',
  'zk.upravtePribeh': 'Edita la experiencia que has compartido.',
  'zk.textPribehu': 'Texto de la experiencia…',
  'zk.fazeTranzice': 'Etapa de la transición',
  'zk.neuvadet': 'No decirlo',
  'zk.ukazeSeLidem': 'La experiencia se mostrará a quien lea la guía de esa etapa.',
  'zk.sdiletPribeh': 'Compartir una experiencia',
  'zk.overEmail': 'Verifica tu correo para compartir una experiencia',
  'zk.zadnePribehy': 'Todavía no hay experiencias. Sé la primera persona.',
  'zk.nazevPribehu': 'El título de tu experiencia…',
  'zk.pribehP': 'Experiencia *',
  'zk.sdilejteZkusenost': 'Comparte tu experiencia con la comunidad…',
  'zk.chybaNacist': 'No se han podido cargar las experiencias',
  'zk.vyplnteNadpis': 'Rellena el titular y el texto',
  'zk.spatnyOdkaz': 'El enlace a la imagen tiene que empezar por http://, https:// o /',
  'zk.sdilen': 'Experiencia compartida.',
  'zk.chybaSdilet': 'No se ha podido compartir',
  'zk.opravduSmazat': '¿Eliminar esta experiencia?',
  'zk.smazan': 'Experiencia eliminada',
  'zk.aktualizovan': 'Experiencia actualizada.',

  // ── rám aplikace ──────────────────────────────────────────────────────────
  'ram.emailNeoveren': 'Tu correo todavía no está verificado. Confírmalo, por favor.',
  'ram.odesilam': 'Enviando…',
  'ram.znovuOdeslat': 'Enviar de nuevo',
  'ram.chceteUpozorneni': '¿Quieres recibir avisos de mensajes nuevos?',
  'ram.tedNe': 'Ahora no',
  'ram.paticka': '© 2026 Bloom – un espacio privado para la comunidad trans',
  'ram.zasadyKomunity': 'Normas de la comunidad',
  'ram.nahlasitProblem': 'Informar de un problema',

  // ── otázky komunity ───────────────────────────────────────────────────────
  'ot.spravce': 'Administración',
  'ot.overenyPravnik': 'Abogacía verificada',
  'ot.overenyOdbornik': 'Profesional verificado',
  'ot.odznakJinaZeme': (p) => `Esta insignia solo vale para: ${p.zeme}`,
  'ot.otazkyKomunity': 'Preguntas de la comunidad',
  'ot.pridatOtazku': 'Añadir una pregunta',
  'ot.novaOtazka': 'Nueva pregunta',
  'ot.naCoSeZeptat': '¿Qué quieres preguntar?',
  'ot.otazkaSeZobrazi': 'Tu pregunta se mostrará a otras personas de la comunidad, que podrán responderla.',
  'ot.otazkaP': 'Pregunta *',
  'ot.oblastTema': 'Área / tema',
  'ot.vseObecna': 'Cualquier cosa (pregunta general)',
  'ot.odeslatOtazku': 'Enviar la pregunta',
  'ot.overEmail': 'Verifica tu correo para poder preguntar',
  'ot.zadneOtazky': 'Todavía no hay preguntas. Sé la primera persona.',
  'ot.hlasu': (p) => (p.pocet === 1 ? 'voto' : 'votos'),
  'ot.odpovedi': (p) => (p.pocet === 1 ? 'respuesta' : 'respuestas'),
  'ot.zadneOdpovedi': 'Todavía no hay respuestas.',
  'ot.napisteOdpoved': 'Escribe una respuesta…',
  'ot.jenPravnici': 'A las preguntas de Ayuda legal responden abogacía verificada y la administración.',
  'ot.smazatOtazku': '¿Eliminar esta pregunta?',

  // ── cizí profil: nabídky, galerie, nahlášení ──────────────────────────────
  'cp.nabidkyAPoptavky': 'Ofertas y peticiones',
  'cp.zadneNabidky': 'Sin ofertas',
  'cp.napsatZpravu': 'Escribir un mensaje',
  'cp.nahlasitUzivatele': 'Denunciar a esta persona',
  'cp.nahlasitKoho': (p) => `Denunciar a ${p.kdo}`,
  'cp.popisteDuvod': 'Cuenta por qué lo denuncias. La denuncia la verá la administración.',
  'cp.zustaneteAnonymni': 'La denuncia la recibe la administración. Tú sigues siendo anónima.',
  'cp.duvodP': 'Motivo *',
  'cp.vybertDuvod': 'Elige un motivo…',
  'cp.nevhodneChovani': 'Comportamiento inadecuado',
  'cp.falesnyProfil': 'Perfil falso',
  'cp.jinyProblem': 'Otro problema',
  'cp.popisVolitelny': 'Descripción',
  'cp.volitelny': '(opcional)',
  'cp.popisteSituaci': 'Cuenta la situación con más detalle…',
  'cp.odeslatNahlaseni': 'Enviar la denuncia',
  'cp.vyberteDuvodChyba': 'Elige un motivo para la denuncia',
  'cp.nahlaseniOdeslano': 'La denuncia se ha enviado a la administración',
  'cp.chybaNahlaseni': 'No se ha podido enviar la denuncia',
  'gal.chranenoHeslem': 'Protegida con contraseña',
  'gal.soukromi': 'Privacidad',
  'gal.nahravam': 'Subiendo…',
  'gal.pridatFotku': 'Añadir una foto',
  'gal.nastaveniSoukromi': 'Privacidad de la galería',
  'gal.verejna': 'Pública',
  'gal.chranenaHeslem': 'Protegida con contraseña',
  'gal.nastaveniUlozeno': 'Ajustes de la galería guardados',
  'gal.jeChranena': 'Esta galería está protegida con contraseña',
  'gal.zadneFotky': 'Todavía no hay fotos. Añade la primera.',
  'gal.otagovat': 'Etiquetar a alguien',
  'gal.hledatUzivatele': 'Buscar a una persona…',
  'gal.odemcena': 'Galería desbloqueada',
  'gal.spatneHeslo': 'Contraseña de la galería incorrecta',
  'gal.fotkaNahrana': 'Foto subida.',
  'gal.chybaNahrat': 'No se ha podido subir la foto',
  'gal.fotkaSmazana': 'Foto eliminada',
  'gal.jizOtagovan': 'Esa persona ya está etiquetada',
  'gal.otagovan': (p) => `Etiquetada: ${p.kdo}`,
  'gal.chybaTag': 'No se ha podido añadir la etiqueta',

  'ram.povolit': 'Permitir',
  'ram.oProjektu': 'El proyecto',
  'ram.prekladNeovereny': 'Nadie que hable este idioma ha revisado todavía esta traducción. Si algo suena mal, dínoslo.',
  'ram.kontakt': 'Contacto',

  // ── mapa světa a počty obsahu ─────────────────────────────────────────────
  'mapa.popis': 'Mapa del mundo – haz clic en un país para abrirlo',
  'mapa.priblizit': 'Acercar',
  'mapa.oddalit': 'Alejar',
  'mapa.celySvet': 'Volver a todo el mundo',
  'mapa.chybaNacteni': 'No se ha podido cargar el mapa',
  'mapa.chybaZkusteSeznam': 'No se ha podido cargar el mapa. Prueba con la lista de países de abajo.',
  'mapa.teprveRoste': 'Bloom apenas empieza aquí',
  'mapa.napovedaDotyk': 'Arrastra para mover el mapa; pellizca, toca dos veces o usa los botones para acercar. No tienes que usarlo: abajo están la búsqueda y la lista completa de países.',
  'obsah.specialists': (p) => (p.pocet === 1 ? 'profesional' : 'profesionales'),
  'obsah.organizations': (p) => (p.pocet === 1 ? 'organización' : 'organizaciones'),
  'obsah.events': (p) => (p.pocet === 1 ? 'evento' : 'eventos'),
  'obsah.pageants': (p) => (p.pocet === 1 ? 'certamen' : 'certámenes'),
  'obsah.resources': (p) => (p.pocet === 1 ? 'recurso' : 'recursos'),
  'obsah.zaznamu': (p) => `${p.pocet} ${p.pocet === 1 ? 'entrada' : 'entradas'}`,

  // ── výběr domovské země ───────────────────────────────────────────────────
  'domov.otazka': '¿Dónde está tu casa?',
  'domov.popis': 'Con eso Bloom te enseñará lo que tienes cerca. Puedes mirar cualquier país: eso no cambia '
      + 'tu país de residencia. No se publica en ningún sitio y puedes cambiarlo cuando quieras.',
  'domov.preskocit': 'Saltar',
  'domov.najitZemi': 'Buscar un país…',
  'domov.nicNeodpovida': 'No hay coincidencias. Prueba otra búsqueda.',
  'domov.klikniDoMapy': 'También puedes hacer clic en un país en el mapa de arriba.',

  // ── vyhledávání v liště ───────────────────────────────────────────────────
  'typ.posts': 'Publicación',
  'typ.users': 'Persona',
  'typ.specialists': 'Profesional',
  'typ.services': 'Oferta',
  'typ.articles': 'Ayuda legal',
  'typ.questions': 'Pregunta de la comunidad',
  'typ.reviews': 'Valoración de un profesional',
  'nav.emailNeoveren': 'Correo sin verificar',
  'nav.neovereny': 'Sin verificar',

  // ── hlášení problému ──────────────────────────────────────────────────────
  'chyba.neco': 'Algo no funciona',
  'chyba.navrh': 'Una propuesta de mejora',
  'chyba.bezpecnost': 'Un problema de seguridad',
  'chyba.jiny': 'Otra cosa',
  'chyba.vyberteTyp': 'Elige el tipo de problema',
  'chyba.popisteProsim': 'Describe el problema',
  'chyba.odeslano': 'Informe enviado, ¡gracias!',
  'chyba.chybaOdeslat': 'No se ha podido enviar el informe',
  'chyba.napisteNam': 'Cuéntanos qué ha pasado: nos ayuda a arreglarlo.',
  'chyba.typProblemu': 'Tipo de problema',
  'chyba.popisProblemu': 'Qué ha pasado',
  'chyba.popisPriklad': 'Cuenta qué ha pasado, qué esperabas y qué ha ocurrido en su lugar…',
  'chyba.priloha': 'Adjuntamos automáticamente: la página actual, la hora y datos sobre tu navegador.',
  'chyba.odeslatHlaseni': 'Enviar el informe',

  // ── editor textu ──────────────────────────────────────────────────────────
  'ed.napisteObsah': 'Escribe el contenido…',
  'ed.tucne': 'Negrita (Ctrl+B)',
  'ed.kurziva': 'Cursiva (Ctrl+I)',
  'ed.odrazky': 'Lista con viñetas',
  'ed.vlozitOdkaz': 'Insertar un enlace',
  'ed.vlozitTabulku': 'Insertar una tabla',
  'ed.radky': 'Filas',
  'ed.sloupce': 'Columnas',
  'ed.vlozit': 'Insertar',
  'ed.barva.cerna': 'Negro',
  'ed.barva.seda': 'Gris',
  'ed.barva.fialova': 'Morado',
  'ed.barva.ruzova': 'Rosa',
  'ed.barva.modra': 'Azul',
  'ed.barva.zelena': 'Verde',
  'ed.barva.cervena': 'Rojo',
  'ed.barva.oranzova': 'Naranja',

  // ── ověření e-mailu a přihlášení přes jiné služby ─────────────────────────
  'over.neplatnyOdkaz': 'Ese enlace de verificación no es válido.',
  'over.hotovo': 'Tu correo está verificado.',
  'over.odkazVyprsel': 'El enlace de verificación no es válido o ha caducado.',
  'over.overuji': 'Verificando tu correo…',
  'over.cekejte': 'Espera un momento.',
  'over.overen': 'Correo verificado.',
  'over.plnyPristup': 'Ya tienes acceso completo a todo Bloom.',
  'over.prejitNaBloom': 'Ir a Bloom',
  'over.selhalo': 'La verificación ha fallado',
  'over.zpetNaPrihlaseni': 'Volver al inicio de sesión',
  'oauth.ucetNenalezen': 'Cuenta no encontrada',
  'oauth.neexistujeGoogle': 'No existe una cuenta de Bloom para esta cuenta de Google. Regístrate primero.',
  'oauth.neexistujeFacebook': 'No existe una cuenta de Bloom para esta cuenta de Facebook. Regístrate primero.',
  'oauth.registrovatGoogle': 'Registrarse con Google',
  'oauth.registrovatFacebook': 'Registrarse con Facebook',
  'oauth.prihlasujiGoogle': 'Iniciando sesión con Google…',
  'oauth.prihlasujiFacebook': 'Iniciando sesión con Facebook…',
  'oauth.facebookSelhalo': 'No se ha podido iniciar sesión con Facebook',

  // ── drobnosti ─────────────────────────────────────────────────────────────
  'obecne.nacitam': 'Cargando…',
  'obecne.nezadano': '— sin indicar —',
  'obecne.neplatnaHodnota': 'Ese valor no es válido.',
  'obecne.strankovani': 'Paginación',
  'navrh.doplnteNazev': 'Rellena el nombre.',
  'navrh.vyberteZemi': 'Elige un país.',
  'navrh.doplnte': (p) => `Rellena: ${p.co}.`,
  'kat.overenoZaznam': 'Comprobado que la entrada corresponde con la realidad',
  'kat.prihlaskyDo': (p) => `Inscripciones hasta el ${p.datum}`,

  'up.odznakAdmin': 'Admin',

  'profil.zalozkaProfil': 'Perfil',
  'profil.zalozkaGalerie': 'Galería',
  'pf.lokalita': 'Ubicación',

  'cesta.legendaBarev': 'Leyenda de colores',

  'hled.pocetVysledku': (p) => `(${p.pocet} ${p.pocet === 1 ? 'resultado' : 'resultados'})`,

  // ── avataři ───────────────────────────────────────────────────────────────
  'avatar.fem-pink': 'Pelo rubio largo',
  'avatar.fem-lavender': 'Pelo morado',
  'avatar.fem-peach': 'Melena con flequillo',
  'avatar.fem-dark': 'Pelo largo oscuro',
  'avatar.fem-straight': 'Pelo pelirrojo',
  'avatar.fem-ponytail': 'Coleta',
  'avatar.masc-blue': 'Pelo rubio corto',
  'avatar.masc-teal': 'Pelo revuelto',
  'avatar.masc-gray': 'Pelo canoso',
  'avatar.masc-short': 'Rapado corto',
  'avatar.nb-mint': 'Pelo verde menta',
  'avatar.nb-lilac': 'Moño alto',
  'avatar.nb-curly': 'Rizos cortos',
  'avatar.nb-sage': 'Pelo por los hombros',
  'avatar.nb-mohawk': 'Cresta',
  'avatar.nb-undercut': 'Undercut',
  'avatar.nb-shaved': 'Cabeza rapada',
  'avatar.nb-glasses': 'Gafas',
  'avatar.animal-cat': 'Gato',
  'avatar.animal-fox': 'Zorro',
  'avatar.animal-rabbit': 'Conejo',
  'avatar.sym-flower': 'Flor',
  'avatar.sym-butterfly': 'Mariposa',
  'avatar.sym-star': 'Estrella',
  'avatar.custom': 'Subir mi propia foto',

  // ── odhlášení po nečinnosti ───────────────────────────────────────────────
  'odhl.necinnost': 'Hemos cerrado tu sesión por inactividad.',
  'odhl.necinnostPopis': 'Bloom no deja la sesión abierta cuando no hay nadie.',
  'odhl.zaChvili': 'Vamos a cerrar tu sesión enseguida',
  'odhl.zaChviliPopis': 'Toca la pantalla o el teclado en cualquier momento y la sesión sigue abierta.',

  'reg.avatarSymboly': 'Símbolos',

  'avatar.fem-bun': 'Moño',
  'avatar.masc-navy': 'Barba completa',
  'avatar.masc-brown': 'Raya al lado',
  'avatar.masc-goatee': 'Perilla',
  'avatar.nb-freckles': 'Pecas',
  'avatar.animal-panda': 'Panda',
  'avatar.animal-owl': 'Búho',
  'avatar.sym-rainbow': 'Arcoíris',
  'avatar.sym-heart': 'Corazón',
  'avatar.sym-lotus': 'Loto (Bloom)',

  'reg.potvrditHeslo': 'Confirmar la contraseña',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vytvorit': 'Crear',
  'obecne.sdilet': 'Compartir',
  'obecne.opravneni': 'Permiso',
  'obecne.pristupGalerie': 'Necesitamos acceso a tus fotos para subir una imagen.',
  'obecne.vsechnyRegiony': 'Todas las regiones',
  'obecne.cesko': 'Chequia',
  'obecne.odbornici': 'Profesionales',
  'obecne.zadnaZprava': 'Sin mensajes',
  'ucet.vyplnteEmailHeslo': 'Introduce tu correo y contraseña',
  'ucet.spatneUdaje': 'Correo o contraseña incorrectos',
  'ucet.googleSelhalo': 'No se pudo iniciar sesión con Google',
  'ucet.skrytHeslo': 'Ocultar contraseña',
  'ucet.emailOveren': 'Tu correo ha sido verificado.',
  'ucet.emailPriklad': 'tu@email.com',
  'ucet.overeniSelhalo': 'La verificación ha fallado.',
  'ucet.overeniSelhaloZnovu': 'La verificación ha fallado. Inténtalo de nuevo.',
  'ucet.komunitniHesloPovinne': 'La contraseña de la comunidad es obligatoria',
  'ucet.zadejteKomunitniHeslo': 'Introduce la contraseña de la comunidad…',
  'ucet.komunitniHesloPopis': 'Bloom es un espacio privado. Alguien de la comunidad puede darte la contraseña.',
  'ucet.prezdivkaMin3': 'El nombre debe tener al menos 3 caracteres',
  'ucet.vyplntePrezdivku': 'Introduce un nombre',
  'ucet.vasePrezdivka': 'Tu nombre',
  'ucet.profilNeulozen': 'No se ha podido guardar el perfil',
  'ucet.anoZrusitProfil': 'Sí, eliminar mi perfil',
  'heslo.min8': 'La contraseña debe tener al menos 8 caracteres',
  'heslo.maleP': 'La contraseña debe incluir una minúscula',
  'heslo.velkeP': 'La contraseña debe incluir una mayúscula',
  'heslo.cislo': 'La contraseña debe incluir un número',
  'heslo.specialni': 'La contraseña debe incluir un carácter especial',
  'heslo.specialniPriklad': 'La contraseña debe incluir un carácter especial (!@#$%)',
  'heslo.napoveda': 'Mín. 8 caracteres, mayúscula, número, especial',
  'profil.oSobe': 'Algo sobre ti…',
  'profil.zajmenaOna': 'ella',
  'profil.zajmenaJine': 'otro',
  'profil.doplnujiciText': 'Nota adicional opcional…',
  'profil.prikladOboru': 'p. ej. cirugía plástica, derecho de familia…',
  'komunita.soukromiNadpis': 'Protegemos la privacidad',
  'komunita.soukromiText': 'Lo que se comparte en Bloom se queda en Bloom.',
  'komunita.podporaText': 'Bloom trata de apoyarse mutuamente.',
  'komunita.neniObchod': 'Bloom no es una plataforma comercial.',
  'komunita.zadneObtezovani': 'El acoso de cualquier tipo no tiene cabida en Bloom.',
  'komunita.oslovovani': 'Nos dirigimos a cada persona con el nombre y los pronombres que usa.',
  'komunita.jakakolivEtapa': 'Estés donde estés en tu camino.',
  'prav.kategZdravi': 'Salud',
  'prav.kategPravni': 'Legal',
  'prav.kategSocialni': 'Social',
  'ot.chybaOdpoved': 'No se ha podido enviar la respuesta.',
  'ot.chybaOtazka': 'No se ha podido publicar la pregunta.',
  'zk.napisteKomentar': 'Escribe un comentario…',
  'zpr.chybaHlasova': 'No se ha podido subir el mensaje de voz. Servidor:',
  'zpr.chybaObrazek': 'No se ha podido subir la imagen. Servidor:',
  'pod.nabizim': 'Ofrezco',
  'pod.coHledate': '¿Qué buscas? (p. ej. masajes, fotografía…)',
  'pod.coNabizite': '¿Qué ofreces? (p. ej. cocina, peluquería…)',
  'pod.lokalitaVolitelna': 'Ubicación (opcional)',
  'pod.podrobnejsiPopis': 'Descripción más detallada *',
  'pod.vyplnteHledate': 'Indica qué buscas.',
  'pod.vyplnteNabizite': 'Indica qué ofreces.',
  'pod.vyplntePopis': 'Añade una descripción.',
  'pod.zadnePrispevky': 'Aún no tienes publicaciones. Crea una oferta o una petición.',
  'svet.vybratZemi': 'Elegir país',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ot.pridat': 'Hacer una pregunta',
  'ot.nadpis': 'Preguntas y respuestas',
  'zk.pridat': 'Añadir una historia',
  'zk.novy': 'Nueva historia',
  'zk.smazat': 'Eliminar historia',
  'zk.zadne': 'Aún no hay historias. Sé la primera persona en compartir.',
  'akt.zadne': 'Aún no hay novedades.',
  'nav.clanky': 'Artículos',
  'ucet.emailOdeslan': 'Correo enviado',
  'ucet.komunitniHeslo': 'Contraseña de la comunidad',
  'ucet.nemateUcet': '¿Aún no tienes cuenta? Regístrate',
  'ucet.muzetePrihlasit': 'Ya puedes iniciar sesión.',
  'ucet.zapomenutePopis': 'Introduce tu correo y te enviaremos un enlace para restablecer la contraseña.',
  'profil.oMneVolitelne': 'Sobre mí (opcional)',
  'profil.prezdivka': 'Nombre',
  'profil.telefonVolitelne': 'Teléfono (opcional)',
  'cesta.poznamkaVolitelna': 'Nota personal (opcional)',
  'okoli.vyberteLokalitu': 'Elige una ubicación arriba',
  'hled.nadpis': 'Búsqueda',
  'hled.popis': 'Busca en toda la aplicación: personas, artículos, historias, reseñas…',
  'hled.min2': 'Escribe al menos 2 caracteres para buscar',
  'pod.vsechnySluzby': 'Todos los servicios',
  'domu.clenoveKomunity': 'Miembros de la comunidad',
  'zpr.zadneKonverzaceHledat': 'Aún no hay conversaciones. Busca a alguien arriba.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'reg.zajmenaOn': 'él',
  'reg.zajmenaOni': 'elle',
  'reg.zajmenaOno': 'ello',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.smazatFotku': 'Eliminar foto',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.nastavteHeslo': 'Define una contraseña para la galería',
  'reg.min3znaky': 'Mín. 3 caracteres',
  'reg.zopakujteHeslo': 'Repite la contraseña',
  'hled.vBloom': 'Buscar en Bloom…',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'profil.upravitProfil': 'Editar perfil',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vybratRegion': 'Elegir región',
  'obecne.region': 'Región',
  'gal.heslemChranena': 'Protegida con contraseña',
  'gal.hesloGalerie': 'Contraseña de la galería',
  'reset.nastavitHeslo': 'Establecer contraseña',
  'reset.hesloObnoveno': 'Contraseña restablecida.',
  'profil.nenalezen': 'Perfil no encontrado',
  'obecne.nebo': 'o',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'auth.dvfNapoveda': 'Abre tu aplicación de códigos y copia los seis dígitos de Bloom. También puedes usar uno de tus códigos de respaldo.',
  'auth.sifrovaniNapoveda': 'Si activaste el cifrado de mensajes en la web, la aplicación aún no puede acceder a esa cuenta. Usa bloomapp.cz en el navegador.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ucet.zobrazitHeslo': 'Mostrar contraseña',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.opravduSmazat': '¿Eliminar esta foto?',
  'dvf.zadejteKod': 'Introduce el código de tu aplicación',
  'sif.odemknoutAplikaci': 'Desbloquear la aplicación',
  'profil.odeslatZnovu': 'Enviar de nuevo',
};

export default es;
